<template>
  <!-- v-if="!photoAlbumDetails.show" -->
  <div @click="toHidePhotoAlbum()">
    <div class="space_details_background" id="scrollDiv">
      <div class="space_details_title_all">
        <div class="space_details_title">纪念堂管理详情</div>
        <img class="iv_close" src="@/assets/images/space/iv_close.png" alt="" @click="closeAll()" />
      </div>

      <div class="space_title">{{ details.name }}的纪念堂</div>
      <div class="space_title_message">
        <div class="space_title_message_conent">
          <div class="titl_text">
            创建日期：<span class="titl_message">{{ details.createTime }}</span>
          </div>
          <div class="titl_text">
            纪念堂编号：<span class="titl_message">{{ details.code }}</span>
          </div>
          <div class="titl_text">
            纪念堂名称：<span class="titl_message">{{ details.name }}</span>
          </div>
          <div class="titl_text">
            主办人手机号：<span class="titl_message">{{
                details.undertakerTel
            }}</span>
          </div>
          <div class="titl_text">
            殡仪馆告别厅：<span class="titl_message">{{ details.nameA }}</span>
          </div>
          <div class="titl_text">
            殡仪馆告别厅使用时间：<span class="titl_message">{{
                details.dateA
            }}</span>
          </div>
          <div class="titl_text">
            陵园告别厅：<span class="titl_message">{{ details.nameB }}</span>
          </div>
          <div class="titl_text">
            陵园告别厅使用时间：<span class="titl_message">{{
                details.dateB
            }}</span>
          </div>
          <div class="titl_text">
            有效日期：<span class="titl_message">{{
                details.foreverState == 1 ? "永久" : details.createAndCloseTime
            }}</span>
          </div>
          <div class="titl_text">
            纪念堂状态：<span class="titl_message">{{ details.statusName }}{{ details.spaceFrozenName }}</span>
          </div>
        </div>
        <div class="titl_text">
          陵园使用：<span class="titl_message">{{ details.cemeteryAll }}</span>
        </div>
        <div class="title_midddle_button">
          <div class="title_midddle_button_text" v-if="pms.qrCode">
            访问码：
          </div>
          <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 10rem; margin-left: 1rem"
            @click="toShowQRCode()" v-if="pms.qrCode" :disabled="!isHaveCover">预览</el-button>
          <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 10rem; margin-left: 2rem" v-if="pms.qrCode"
            :disabled="!isHaveCover" @click="exportQrcodePicTimerAnother()">下载</el-button>
          <div class="title_midddle_button_text" style="margin-left: 3rem" v-if="pms.claimCode">
            认领码：
          </div>
          <!-- <el-button :type="details.claimState == 0 ? 'primary' : 'info'" style="width: 10rem; margin-left: 1rem"
            @click="toShowQRCodeClaim()" v-if="pms.claimCode" :disabled="details.claimState != 0">预览</el-button> -->
          <el-button :type="details.claimState == 0 ? 'primary' : 'info'" style="margin-left: 1rem;"
            v-if="pms.claimCodeApp" :disabled="details.claimState != 0" @click="exportQrcodePicTimerAnotherClaimApp()">App认领码下载
          </el-button>
          <el-button :type="details.claimState == 0 ? 'primary' : 'info'" style="margin-left: 2rem;"
            v-if="pms.claimCode" :disabled="details.claimState != 0" @click="exportQrcodePicTimerAnotherClaim()">小程序认领码下载
          </el-button>
          <el-button :type="details.claimState == 0 ? 'primary' : 'info'" style="margin-left: 2rem;"
            v-if="pms.claimCodeAll" :disabled="details.claimState != 0" @click="exportQrcodePicTimerAnotherClaimAll()">认领码下载
          </el-button>
          <el-button :type="details.spaceFrozen != 0 || !canType ? 'info' : 'primary'"
            style="width: 12rem;margin-left:12rem;" v-if="pms.cemeteryUse" @click="cemeteryUse()"
            :disabled="details.spaceFrozen != 0 || !canType">陵园使用
          </el-button>
          <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 14rem; margin-left: 5rem"
            :class="isHaveCover ? 'v_green' : ''" v-if="pms.freezingSpace && details.spaceFrozen == 0"
            @click="getPhoneMessageClock" :disabled="!isHaveCover">冻结纪念堂</el-button>
          <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 14rem; margin-left: 5rem"
            :class="isHaveCover ? 'v_green' : ''" v-if="pms.relieveS && details.spaceFrozen != 0"
            @click="getPhoneMessageClockA" :disabled="!isHaveCover">解除纪念堂冻结</el-button>
        </div>
        <div class="v_line"></div>

        <div class="title_midddle_button_text_bg" style="margin-left: 3rem" v-if="pms.posterse">横版海报：</div>

        <div class="title_bottom_button_list" style="margin-left:3rem;margin-bottom:2rem;" v-if="pms.posterse">
          <div class="title_bottom_button_list_item" v-for="(item, index) in details.posterTemplateList" :key="index"
          style="margin-right:7.5rem;">
            <img class="title_bottom_button_list_item_img" :src="item.bgUrl" alt="" />
            <div style="margin-top:2rem;" class="title_bottom_button_list_item_bottom">
              <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 10rem;"
                @click="toShowPoster(item.bgUrl,item.fontColor)" v-if="pms.posterse" :disabled="!isHaveCover">预览</el-button>
              <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 10rem; margin-left: 2rem"
                v-if="pms.posterse" :disabled="!isHaveCover" @click="downImage(item.bgUrl,item.fontColor)">下载</el-button>
            </div>
          </div>
        </div>

        <div class="title_midddle_button_text_bg" style="margin-left: 3rem" v-if="pms.posterse">竖版海报：</div>

        <div class="title_bottom_button_list" style="margin-left:3rem;margin-bottom:2rem;" v-if="pms.posterse">
          <div class="title_bottom_button_list_item" v-for="(item, index) in details.posterVerticalTemplateList" :key="index"
          style="margin-right:7.5rem;">
            <img class="title_bottom_button_list_item_img_v" :src="item.bgUrl" alt="" />
            <div style="margin-top:2rem;" class="title_bottom_button_list_item_bottom">
              <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 10rem;"
                @click="toShowClaimCode(item.bgUrl,item.fontColor)" v-if="pms.posterse" :disabled="!isHaveCover">预览</el-button>
              <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 10rem; margin-left: 2rem"
                v-if="pms.posterse" :disabled="!isHaveCover" @click="downImageClaimCode(item.bgUrl,item.fontColor)">下载</el-button>
            </div>
          </div>
        </div>
        <!-- <div class="title_bottom_button">
          <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 10rem; margin-left: 1rem"
            @click="toShowClaimCode()" v-if="pms.posterse" :disabled="!isHaveCover">预览</el-button>
          <el-button :type="isHaveCover ? 'primary' : 'info'" style="width: 10rem; margin-left: 2rem"
            v-if="pms.posterse" :disabled="!isHaveCover" @click="downImageClaimCode()">下载</el-button>
        </div> -->
      </div>

      <div class="space_change_all">
        <div class="space_change_all_title" ref="obtainA">
          <div class="space_change_all_title_text">编辑</div>
          <el-button class="space_homepage_message" style="width: 19rem" @click="getPhoneMessage"
            :type="isHaveCover ? 'primary' : 'info'" :disabled="!updateState || !isHaveCover"
            v-if="updateState && pms.change && details.claimState == 1">获取操作权限验证码</el-button>
          <div v-if="!updateState && pms.change">
            <el-button class="space_homepage_message_a" :type="isHaveCover ? 'primary' : 'info'" @click="save(1)"
              :disabled="updateState || !isHaveCover" v-if="!updateState && pms.change && details.claimState == 1">保存
            </el-button>
            <el-button class="space_homepage_message" :type="isHaveCover ? 'primary' : 'info'" @click="save(0)"
              :disabled="updateState || !isHaveCover" v-if="!updateState && pms.change">{{ details.claimState ==
                  1 ? '保存并结束' : '保存'
              
              
              
              }}</el-button>
          </div>
        </div>

        <div class="space_homepage">
          <div class="space_homepage_title">逝者信息</div>
        </div>
        <div class="space_homepage_middle">
          <div class="search_area" style="margin-bottom: 1rem">
            <el-form ref="form" :model="spaceHomeForm" label-width="7rem" :inline="true" :rules="spaceHomeRules">
              <el-form-item class="search_item" label="纪念堂名称：" label-width="12rem" prop="name">
                <el-input class="search_input" style="width: 47rem" maxlength="30" placeholder="请输入纪念堂名称"
                  v-model="spaceHomeForm.name" clearable :disabled="updateState"></el-input>
              </el-form-item>
              <el-form-item class="search_item" label="性别：" label-width="6rem">
                <el-select class="search_input_new" v-model="spaceHomeForm.sex" placeholder="请选择"
                  :disabled="updateState">
                  <el-option v-for="(item, index) in stateList" :label="item.areaName" :value="item.areaId"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="search_item" label="生/忌辰显示：" label-width="11rem">
                <el-select class="search_input_new" v-model="spaceHomeForm.calendarState" placeholder="请选择"
                  :disabled="updateState" @change="changeCalendar">
                  <el-option v-for="(item, index) in calendarList" :label="item.areaName" :value="item.areaId"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="search_item" label="生辰：" label-width="6rem">
                <!-- <el-date-picker v-model="spaceHomeForm.birthday" type="date" placeholder="年/月/日"
                  value-format="yyyy-MM-dd" :picker-options="datePickerOptions" :disabled="updateState">
                </el-date-picker> -->
                <el-input class="search_input" style="width: 19rem" placeholder="年/月/日" v-model="spaceHomeForm.birthday"
                  clearable :disabled="updateState" v-if="updateState"></el-input>
                <div class="calerdar_chocie" @click="toShowCalendar(1)" v-if="!updateState">
                  <div v-if="spaceHomeForm.birthday == undefined || spaceHomeForm.birthday == ''"
                    style="margin-left:1.5rem;" class="calerdar_chocie_none">年/月/日</div>
                  <div v-if="spaceHomeForm.birthday != undefined && spaceHomeForm.birthday != ''"
                    style="margin-left:1.5rem;">{{ spaceHomeForm.birthday }}</div>
                  <i v-if="spaceHomeForm.birthday != undefined && spaceHomeForm.birthday != ''"
                    style="padding:1.5rem;color: #C0C4CC;cursor: pointer;" class="el-icon-circle-close"
                    @click.stop="deleteCalendar(1)"></i>
                </div>
              </el-form-item>

              <el-form-item class="search_item" label="忌辰：" label-width="6rem">
                <!-- <el-date-picker v-model="spaceHomeForm.deadday" type="date" placeholder="年/月/日"
                  value-format="yyyy-MM-dd" :picker-options="datePickerOptions" :disabled="updateState">
                </el-date-picker> -->
                <el-input class="search_input" style="width: 19rem" placeholder="年/月/日" v-model="spaceHomeForm.deadday"
                  clearable :disabled="updateState" v-if="updateState"></el-input>
                <div class="calerdar_chocie" @click="toShowCalendar(2)" v-if="!updateState">
                  <div v-if="spaceHomeForm.deadday == undefined || spaceHomeForm.deadday == ''"
                    style="margin-left:1.5rem;" class="calerdar_chocie_none">年/月/日</div>
                  <div v-if="spaceHomeForm.deadday != undefined && spaceHomeForm.deadday != ''"
                    style="margin-left:1.5rem;">{{ spaceHomeForm.deadday }}</div>
                  <i v-if="spaceHomeForm.deadday != undefined && spaceHomeForm.deadday != ''"
                    style="padding:1.5rem;color: #C0C4CC;cursor: pointer;" class="el-icon-circle-close"
                    @click.stop="deleteCalendar(2)"></i>
                </div>
              </el-form-item>

            </el-form>
          </div>
        </div>


        <div class="visitors_to_code">访问码</div>
        <div class="visitors_body">
          <div>
            <el-form ref="form" :model="shareCoverForm" label-width="11rem" :disabled="updateState"
              :rules="shareCoverRules">
              <el-form-item class="search_itema" label="纪念堂封面：" prop="coverUrl" label-width="12rem">
                <OSSUpload :type="11" :dmId="details.id" :imageUrl="details.coverUrl" @fileInfo="coverFileInfo"
                  :memorySize="details.fileSizeUse" :memorySizeAll="details.fileSizeCount" :class="
                    details.coverUrl
                      ? updateState
                        ? 'coverUrlBorder'
                        : 'coverUrlBorderA'
                      : updateState
                        ? ''
                        : ''
                  " v-if="toShowCover"></OSSUpload>
                <OSSUpload :type="11" :dmId="details.id" :imageUrl="details.coverUrl" @fileInfo="coverFileInfo"
                  :memorySize="details.fileSizeUse" :memorySizeAll="details.fileSizeCount" :class="
                    details.coverUrl
                      ? updateState
                        ? 'coverUrlBorder'
                        : 'coverUrlBorderA'
                      : updateState
                        ? ''
                        : ''
                  " v-if="!toShowCover"></OSSUpload>
                <p class="instructions">
                  照片格式为jpg或png，大小为10KB~10MB，图片尺寸为285×380
                </p>
              </el-form-item>
            </el-form>
          </div>
          <div class="v_line_middle"></div>
          <div class="headline_title">生平标题：</div>
          <el-input class="headline_input" maxlength="8" placeholder="请输入生平标题" v-model.trim="lifeTitle1" clearable
            :disabled="updateState"></el-input>
            <div class="headline_title">模板选择：</div>
            <div class="template_list">
              <div class="blank" v-if="templateTableData.length == 0">暂无模板</div>
              <div :class="updateState?'template_btn_area disable':'template_btn_area'" v-for="(item_template,index_template) in templateTableData" :key="index_template" @click="btn_lifestory_template_Click(index_template,updateState)">
                <div class="name selected" v-if="curr_leftstory_temp_index == index_template">{{ item_template.name }}</div>
                <div class="name" v-else>{{ item_template.name }}</div>
                <img class="img_template_triangle" v-if="curr_leftstory_temp_index == index_template" src="@/assets/images/space/triangle_blue.png" alt="">
              </div>
            </div>
          <div class="headline_title">生平：</div>
          <div style="width: 168rem; margin-left: 3rem" class="wang_editor_all">
            <div ref="editorElem1" style="text-align: left"></div>
            <div class="wang_editor_all_number">
              <span :style="
                editor1TextLength > 20100 ? 'color:red' : 'color:#2C90FF'
              ">{{ editor1TextLength }}</span>/20100
            </div>
          </div>

          <div class="v_line_middle" style="margin-top: 3rem"></div>

          <!-- 背景模板 -->
          <div :class="bgTemplateTitleNewClass" @click="bgTemplateTitleClick('NEW')">背景模版</div>
          <div :class="bgTemplateTitleOldClass" @click="bgTemplateTitleClick('OLD')">历史模版</div>
          <div class="bg_template_body">
            <div class="v_template_imgs">
              <div class="bg_template_body_item" v-for="(item, i) in listArr" :key="i" 
                @click="choiceBack(i, item.bgId)" v-show="item.bgId >= 9000 ? bgTemplateBodyNewShow : bgTemplateBodyOldShow">
                <!-- '?x-oss-process=video/snapshot,t_1000,f_jpg,ar_auto' -->
                <img class="iv_template" :src="item.url" alt="" :style="
                  updateState ? 'cursor: not-allowed;' : 'cursor: pointer;'
                " />
                <div class="chocie_template" :style="
                  updateState ? 'cursor: not-allowed;' : 'cursor: pointer;'
                ">
                  <img class="iv_choice_icon" src="@/assets/images/space/iv_choice_yes.png" alt=""
                    v-if="i == indexBack" />
                  <img class="iv_choice_icon" src="@/assets/images/space/iv_choice_no.png" alt="" v-if="i != indexBack" />
                  <div>{{ item.name }}</div>
                </div>
                <img class="iv_choice_title" src="@/assets/images/space/iv_choice_title.png" alt=""
                  v-if="i == indexBack" />
              </div>
            </div>
          </div>

          <div class="v_line_middle"></div>
          <div class="v_template">
            音乐模版：<span class="v_template_name">{{
                getBGMname(TemplateSettingsFromData.msId)
            }}</span>
          </div>

          <div class="v_template_imgs">
            <div class="v_template_item" v-for="(item, i) in imgListMusic" :key="i" :style="
              i % 8 == 0 ? 'margin-left: 0rem;' : 'margin-left: 3.9rem;'
            " @click="choiceMusic(i, item.id)">
              <img class="iv_music" src="@/assets/images/space/music-bg.png" alt="" :style="
                updateState ? 'cursor: not-allowed;' : 'cursor: pointer;'
              " />
              <img class="iv_music_button" src="@/assets/images/space/iv_music_play.png" alt=""
                @click.stop="pauseAudio(i)" v-if="item.isPlay" :style="
                  updateState ? 'cursor: not-allowed;' : 'cursor: pointer;'
                " />
              <div class="iv_music_button_text" v-if="item.isPlay">
                点击暂停
              </div>
              <img class="iv_music_button" src="@/assets/images/space/iv_music_stop.png" alt=""
                @click.stop="playAudio(item.url, i, item.id)" v-if="!item.isPlay" :style="
                  updateState ? 'cursor: not-allowed;' : 'cursor: pointer;'
                " />
              <div class="iv_music_button_text" v-if="!item.isPlay">
                点击试听
              </div>
              <div class="chocie_template" :style="
                updateState ? 'cursor: not-allowed;' : 'cursor: pointer;'
              ">
                <img class="iv_choice_icon" src="@/assets/images/space/iv_choice_yes.png" alt=""
                  v-if="i == indexMusic" />
                <img class="iv_choice_icon" src="@/assets/images/space/iv_choice_no.png" alt=""
                  v-if="i != indexMusic" />
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>

          <audio id="audioMusic" :src="audioMusicPath"></audio>
        </div>
      </div>

      <div class="visitors_to_code_s" ref="obtainC">
        <div class="visitors_to_code_s_title">资料</div>
        <div>
          <el-button style="width: 12rem;margin-right:3rem;" type="primary" @click="updateLog()">上传记录</el-button>
          <el-button class="space_homepage_message" style="width: 19rem;margin-left:0rem;"
            @click="getPhoneMessageUpdate" v-if="
              pms.uploading &&
              uploadState &&
              details.claimState == 1
            " :disabled="!uploadState || !isHaveCover" :type="isHaveCover ? 'primary' : 'info'">获取操作权限验证码</el-button>
          <el-button class="space_homepage_message" style="width: 19rem;margin-left:0rem;"
            v-if="pms.uploading && !uploadState" :disabled="uploadState || !isHaveCover"
            :type="isHaveCover ? 'primary' : 'info'" @click="upLoadFinish">结束操作
          </el-button>
        </div>
      </div>

      <div class="visitors_body_update">
        <div class="progress_top_new">
          <div class="progress_top_left_new">
            <div class="progress_top_left_new_text">
              纪念堂大小 {{ details.fileSizeCount / 1024 / 1024 }}G
            </div>
            <div class="progress_top_left_new_right_text">
              已使用 {{ details.fileSizeUseA }}G/{{
                  details.fileSizeCount / 1024 / 1024
              }}G
            </div>
          </div>
          <div class="progress_line_new">
            <div class="progress_line_new_blue" :style="{ 'flex-grow': details.fileVideoSizeUsef }"></div>
            <div class="progress_line_new_pink" :style="{ 'flex-grow': details.filePicSizeUsef }"></div>
            <div class="progress_line_new_gray"
              :style="{ 'flex-grow': 100 - details.fileVideoSizeUsef - details.filePicSizeUsef }"></div>
          </div>
        </div>

        <div class="upload_middle">
          <div class="upload_middle_item">
            <img class="iv_upload_middle_item" src="@/assets/images/space/iv_video.png" alt="" />
            <div>
              <div class="v_upload_middle_number" style="color: #0884ff">
                {{ details.fileVideoCount }}
              </div>
              <div class="v_upload_middle_text">视频总数</div>
            </div>
          </div>
          <div class="upload_middle_item" style="margin-left: 6rem">
            <img class="iv_upload_middle_item" src="@/assets/images/space/iv_image.png" alt="" />
            <div>
              <div class="v_upload_middle_number" style="color: #aa28d4">
                {{ details.filePicCount }}
              </div>
              <div class="v_upload_middle_text">图片总数</div>
            </div>
          </div>
          <div class="upload_middle_item" style="margin-left: 6rem">
            <img class="iv_upload_middle_item" src="@/assets/images/space/iv_qr_code.png" alt="" />
            <div>
              <div class="v_upload_middle_number" style="color: #37cde5">
                {{ details.viewCount }}
              </div>
              <div class="v_upload_middle_text">访问码浏览总数</div>
            </div>
          </div>
        </div>

        <div class="v_line_middle" style="width: 174rem"></div>

        <div class="v_photo_album_list">
          <div class="v_photo_album_list_item" v-for="(item, i) in photoCategoryList" :key="i"
            :style="i % 6 == 0 ? 'margin-left: 0rem;' : 'margin-left: 3rem;'">


            <img v-if="item.coverUrl != undefined" class="iv_photo_album_list_item" :src="item.coverUrl" alt=""
              @click.stop="choicePhotoDetails(i)" :style="uploadState ? 'cursor: not-allowed;' : 'cursor: pointer;'" />

            <div class="iv_photo_album_list_item_none" v-if="item.coverAuto == 1 && item.coverUrl == undefined"
              :style="uploadState ? 'cursor: not-allowed;' : 'cursor: pointer;'" @click.stop="choicePhotoDetails(i)">
              <img class="v_photo_album_list_item_change_add" src="@/assets/images/space/iv_update_add.png" alt=""
                @click.stop="choicePhotoDetails(i)"
                :style="uploadState ? 'cursor: not-allowed;' : 'cursor: pointer;'" />
            </div>

            <div class="v_photo_album_list_item_bottom">
              <div class="v_photo_album_list_item_bottom_title">{{ item.name }}</div>
              <img class="iv_photo_album_list_item_bottom_right" src="@/assets/images/space/iv_three_dot.png" alt=""
                @click.stop="toShowItem(i)" :style="uploadState ? 'cursor: not-allowed;' : 'cursor: pointer;'" />
            </div>

            <img class="v_photo_album_list_item_change" v-if="item.coverAuto == 1 && item.coverUrl != undefined"
              src="@/assets/images/space/iv_update_newest.png" alt="" @click.stop="choicePhotoDetails(i)"
              :style="uploadState ? 'cursor: not-allowed;' : 'cursor: pointer;'" />

              <div class="v_photo_album_list_item_photo_count">{{ item.photoNum }}张照片</div>

            <div class="v_photo_album_list_item_float" v-if="item.show">
              <div class="v_photo_album_list_item_float_all" @click="setPhotoAlbum(i)">
                <img class="iv_photo_album_list_item_float_icon" src="@/assets/images/space/iv_photo_set.png" alt="" />
                <div class="v_photo_album_list_item_float_black">相册设置</div>
              </div>
              <div class="v_photo_album_list_item_float_line" v-if="item.adminShowDel == 1"></div>
              <div class="v_photo_album_list_item_float_all" @click="deleteAlbum(item)" v-if="item.adminShowDel == 1">
                <img class="iv_photo_album_list_item_float_icon" src="@/assets/images/space/iv_photo_delete.png"
                  alt="" />
                <div class="v_photo_album_list_item_float_red">删除相册</div>
              </div>
            </div>
          </div>
        </div>

        <div class="v_line_middle" style="width: 174rem; margin-top: 2rem" v-if="pms.uploading && (!uploadState)"></div>

        <!-- <el-upload
          :data="OSSInfo"
          action=""
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :on-progress="uploadVideoProcess"
          :on-error="handleAvatarError"
          :file-list="file_list"
          :on-exceed="onEexceed"
          :http-request="myFileUpload"
          :limit="10"
          v-if="!uploadState && pms.uploading"
          multiple
          ref="upLoad"
          class="upLoadVideo_all"
        >
          <el-button
            size="small"
            :type="uploadState ? 'info' : 'primary'"
            class="upLoadVideo"
            :disabled="uploadState"
            v-if="pms.uploading"
            >上传</el-button
          >
        </el-upload>

        <el-button
          :type="uploadState ? 'info' : 'primary'"
          class="upLoadVideo_no"
          :disabled="uploadState"
          v-if="pms.uploading && uploadState"
          >上传</el-button
        > -->

        <el-button :type="uploadState ? 'info' : 'primary'" class="upLoadVideo_no" @click="toCreatedPhotoAlbum"
          v-if="pms.uploading && (!uploadState)">新建</el-button>
      </div>

      <!-- 人生相册-开始 -->
      <template v-if="pms.lifeAlbum">
        <div class="lifeAlbum_body" ref="lifeAlbumRef">
          <div class="lifeAlbum_title">人生相册</div>
        </div>
        <div class="lifeAlbum_content">
          <space-life-album  ref="spaceLifeAlbumRef"/>
        </div>
      </template>
      <!-- 人生相册-结束 -->

      <el-dialog title="获取操作权限验证码" width="61rem" :visible.sync="phoneDialog" :close-on-click-modal="false"
        :before-close="handlePhoneClose">
        <div class="dialog_body_message" style="margin-bottom: 3rem">
          <div class="phone_message_text">验证码：</div>
          <el-input class="phone_message" maxlength="6" placeholder="请输入验证码" v-model="message" @input="
            (v) => {
              message = v.replace(/[^\d]/g, '');
            }
          " clearable></el-input>
          <el-button class="message_to_phone" v-if="!timer" @click="getMessage">获取验证码</el-button>
          <el-button v-else class="message_to_phone">{{ totleTime }}s</el-button>
        </div>

        <div slot="footer">
          <el-button style="width: 10rem; margin-right: 1.5rem" @click="dialogPhoneCancel()" class="btn_cancle_dialog">
            取消</el-button>
          <el-button class="dialog_button" style="background-color: #4ea2ff; border-color: #4ea2ff" type="primary"
            @click="dialogPhoneSave()">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="获取操作权限验证码" width="61rem" :visible.sync="phoneUpdateDialog" :close-on-click-modal="false"
        :before-close="handlePhoneUpdateClose">
        <div class="dialog_body_message" style="margin-bottom: 3rem">
          <div class="phone_message_text">验证码：</div>
          <el-input class="phone_message" maxlength="6" placeholder="请输入验证码" v-model="messageUpdate" @input="
            (v) => {
              messageUpdate = v.replace(/[^\d]/g, '');
            }
          " clearable></el-input>
          <el-button class="message_to_phone" v-if="!timerUpdate" @click="getMessageUpdate">获取验证码</el-button>
          <el-button v-else class="message_to_phone">{{ totleTimeUpdate }}s</el-button>
        </div>

        <div slot="footer">
          <el-button style="width: 10rem; margin-right: 1.5rem" @click="dialogPhoneUpdateCancel()"
            class="btn_cancle_dialog">取消</el-button>
          <el-button class="dialog_button" style="background-color: #4ea2ff; border-color: #4ea2ff" type="primary"
            @click="dialogPhoneUpdateSave()">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="clock ? '冻结纪念堂' : '解除纪念堂冻结'" width="61rem" :visible.sync="phoneClockDialog"
        :close-on-click-modal="false" :before-close="handlePhoneClockClose">
        <div class="freezeSpace" v-if="clock">
          <div class="cemetery_use_title_b">请填写冻结纪念堂理由：</div>
          <el-input class="search_input_big" type="textarea" v-model.trim="freezeRemark" placeholder="请输入内容" :rows="4"
            maxlength="100" resize="none"></el-input>
          <span class="search_input_big_number_b">{{ freezeRemark | remarkLength
          }}<span class="search_input_big_number_a">/100</span></span>
        </div>

        <div class="dialog_body_message" style="margin-bottom: 3rem">
          <div class="phone_message_text">验证码：</div>
          <el-input class="phone_message" maxlength="6" placeholder="请输入验证码" v-model.trim="messageClock" clearable>
          </el-input>
          <el-button class="message_to_phone" v-if="!timerClock" @click="getMessageClock">获取验证码</el-button>
          <el-button v-else class="message_to_phone">{{ totleTimeClock }}s</el-button>
        </div>

        <div slot="footer">
          <el-button style="width: 10rem; margin-right: 1.5rem" @click="dialogPhoneClockCancel()"
            class="btn_cancle_dialog">取消</el-button>
          <el-button class="dialog_button" style="background-color: #4ea2ff; border-color: #4ea2ff" type="primary"
            @click="dialogPhoneClockSave(clock)">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog class="calendar_dialog" :title="calendarType == 1 ? '生辰' : '忌辰'" width="62rem"
        :visible.sync="calendarDialog" :close-on-click-modal="false" :before-close="handleCalendarClose">
        <div>
          <div style="width:58rem;height:64rem;" v-if="calendarDialog">
            <datePick @updateLunar="updateLunar"
              :chocieDay="calendarType == 1 ? ((spaceHomeForm.birthdaySolar != undefined && spaceHomeForm.birthdaySolar != '') ? spaceHomeForm.birthdaySolar : dateNow) : ((spaceHomeForm.deaddaySolar != undefined && spaceHomeForm.deaddaySolar != '') ? spaceHomeForm.deaddaySolar : dateNow)"
              :nowDay="dateNow">
            </datePick>
          </div>
        </div>
        <!-- <div slot="footer">
          <el-button style="width: 10rem; margin-right: 1.5rem" @click="dialogCalendarCancel()"
            class="btn_cancle_dialog">取消</el-button>
          <el-button class="dialog_button" style="background-color: #4ea2ff; border-color: #4ea2ff" type="primary"
            @click="dialogCalendarSave()">确定</el-button>
        </div> -->
      </el-dialog>

      <el-dialog title="陵园使用" width="61rem" :visible.sync="cemeteryUseDialog" :close-on-click-modal="false"
        :before-close="handleCemeteryClose">
        <div class="dialog_body_create" style="margin-bottom: 3rem">
          <div class="cemetery_use">
            <div class="cemetery_use_title">陵园使用：</div>
            <el-input class="search_input_big" type="textarea" v-model.trim="cemeteryText" placeholder="请输入内容" :rows="4"
              resize="none" maxlength="100">
            </el-input>
            <span class="search_input_big_number">{{ cemeteryText | remarkLength
            }}<span class="search_input_big_number_a">/100</span></span>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button style="width: 10rem; margin-right: 1.5rem" plain @click="dialogCemeteryCancel()">取消</el-button>
          <el-button class="dialog_button" style="background-color: #4ea2ff; border-color: #4ea2ff" type="primary"
            @click="dialogCemeterySave()">确定</el-button>
        </div>
      </el-dialog>

      <el-drawer title="上传记录" :visible.sync="tableLog" direction="rtl" :size="drawarWidth" custom-class="drawer_change"
        :before-close="handleCloseLog" :wrapperClosable="false">
        <div class="search_area_log_middle">
          <div class="search_area_log_search">查询</div>
          <div class="search_area_log">
            <el-form ref="form" :model="spaceLogForm" label-width="10rem">
              <el-form-item class="search_itemb" label="操作员：">
                <el-input class="search_input" maxlength="60" placeholder="请输入操作员名称"
                  v-model.trim="spaceLogForm.createUserName" clearable></el-input>
              </el-form-item>

              <el-form-item class="search_itemb" label="操作日期：" label-width="11rem">
                <el-date-picker v-model="spaceLogForm.date" type="daterange" range-separator="-"
                  value-format="yyyy-MM-dd" start-placeholder="年/月/日" end-placeholder="年/月/日"
                  :picker-options="datePickerOptions">
                </el-date-picker>
              </el-form-item>

              <el-form-item class="search_itemb" label-width="3rem">
                <el-button class="search_button" type="primary" @click="searchLog()"
                  style="background-color: #4ea2ff; border-color: #4ea2ff">查询</el-button>
              </el-form-item>
            </el-form>
          </div>

          <div class="table_area_log_all">
            <div class="log_number_all">
              合计：<span class="log_number_blue">{{ numberLog }}</span>
            </div>

            <div class="table_area_log">
              <el-table :data="logList">
                <el-table-column prop="index" label="序号" :width="10.0 * docFontSize"></el-table-column>
                <el-table-column label="操作员信息" :width="19.0 * docFontSize">
                  <template slot-scope="scope">
                    <div>
                      <div class="v_item_name" v-if="scope.row.unitShortName">
                        {{ scope.row.unitShortName }}
                      </div>
                      <div class="v_item_name">
                        {{ scope.row.createAdminName }}
                      </div>
                      <!-- <div class="v_item_name" v-if="scope.row.createUserNick">
                        使用者：{{ scope.row.createUserNick }}
                      </div> -->
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="上传内容" :width="40.0 * docFontSize">
                  <template slot-scope="scope">
                    <div class="table_area_log_item_all">
                      <img :src="scope.row.photoUrl" class="table_area_log_item_all_img" />
                      <div class="table_area_log_item_all_text">
                        {{ scope.row.title }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="content" label="上传结果" :width="14.0 * docFontSize"></el-table-column>
                <el-table-column prop="photoCategoryNameNew" label="当前位置" :width="15.0 * docFontSize"></el-table-column>
                <el-table-column prop="updateTime" label="操作日期"></el-table-column>
                <!-- <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="toDeleteImgLog(scope.row.id)" :style="
                      scope.row.claimState || scope.row.uploadState
                        ? 'padding: 0.8rem 0rem; color: #C0C4CC'
                        : 'padding: 0.8rem 0rem; color: #ff4a24'
                    " :disabled="scope.row.claimState || scope.row.uploadState">删除</el-button>
                  </template>
                </el-table-column> -->
                <template slot="empty">
                  <table-empty></table-empty>
                </template>
              </el-table>
            </div>
            <div class="page_area">
              <el-pagination :current-page.sync="pageManagementLog.page" layout="total, prev, pager, next, jumper"
                :total="pageManagementLog.total" @current-change="handleCurrentChangeLog" :page-size="9">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>

    <div class="v_title_button" v-if="!photoAlbumDetails.show && !photoAlbumDetails.aiShow">
      <div :class="titleNumber == 1 ? 'v_title_button_a' : 'v_title_button_b'" @click="toGoPage(1)">
        顶部
      </div>
      <div :class="titleNumber == 2 ? 'v_title_button_a' : 'v_title_button_b'" style="margin-top: 3rem"
        @click="toGoPage(2)">
        编辑
      </div>
      <div :class="titleNumber == 4 ? 'v_title_button_a' : 'v_title_button_b'" style="margin-top: 3rem"
        @click="toGoPage(4)">
        资料
      </div>
      <div v-if="pms.lifeAlbum" :class="titleNumber == 5 ? 'v_title_button_a' : 'v_title_button_b'" style="margin-top: 3rem"
        @click="toGoPage(5)">
        人生相册
      </div>
    </div>

  </div>
</template>

<script>
import TableEmpty from "../../../../components/TableEmpty.vue";
import OSSUpload from "@/components/OSSUpload";
import mixin from "./Mixins";
import datePick from "@/components/datePick";
import calendar from '@/utils/calendar'
import {
  catchErr,
  roundAll,
  nowDate,
  seconds,
  updataLink,
} from "@/utils/utils";
import {
  _getOSSsignature,
  _editUpdateStateSendCode,
  _editUploadStateSendCode,
  _editSpaceFrozenSendCode,
} from "@/api/Common";
import axios from "axios";
import E from "wangeditor";
const OSS = require("ali-oss");
const { $, BtnMenu, DropListMenu, PanelMenu, DropList, Panel, Tooltip } = E;
class AlertMenu extends BtnMenu {
  constructor(editor) {
    const $elem = E.$(
      `<div class="w-e-menu" data-title="首行缩进">
                <i class="w-e-icon-indent-increase"></i>
            </div>`
    );
    super($elem, editor);
  }
  // 菜单点击事件
  clickHandler() {
    let domThis = this.editor.selection.getSelectionContainerElem().elems[0];
    if (domThis.style["text-indent"] == "2em") {
      domThis.style["text-indent"] = "0";
      this.unActive();
    } else {
      domThis.style["text-indent"] = "2em";
      this.active();
    }
  }
  tryChangeActive() {
    let domThis = this.editor.selection.getSelectionContainerElem().elems[0];
    if (domThis.style["text-indent"] == "2em") {
      this.active();
    } else {
      this.unActive();
    }
  }
}

export default {
  mixins: [mixin],
  components: {
    OSSUpload,
    TableEmpty,
    datePick,
  },
  data() {
    return {
      defaultDate: "2018-06-26",
      dateA: ["2019-09-07"],

      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },

      shareCoverForm: {},
      titleNumber: 1,
      showIcon: false,

      spaceHomeRules: {
        name: [
          {
            required: true,
            min: 2,
            max: 30,
            message: "* 请输入正确的纪念堂名称（最少2个字，最多30个字）",
            trigger: "blur",
          },
        ],
      },

      shareCoverRules: {
        coverUrl: [
          {
            required: true,
            message: "* 请添加纪念堂封面",
            trigger: "blur",
          },
        ],
      },

      //背景模板
      indexBack: 0,
      TemplateSettingsFromData: {},
      listArr: [],
      bgTemplateTitleNewClass: "bg_template_title",
      bgTemplateTitleOldClass: "bg_template_title",
      bgTemplateBodyNewShow: false,
      bgTemplateBodyOldShow: false,

      //音乐模板
      indexMusic: 0,
      imgListMusic: [],
      audioMusicPath: "",
      phoneDialog: false,
      message: "",
      messageClock: "",
      phoneClockDialog: false,
      freezeRemark: "",
      messageUpdate: "",
      phoneUpdateDialog: false,

      //上视频
      file: {
        name: "",
        url: "",
        wh: "",
      },

      videoUploadPercent: 0,
      fileTitle: "",
      intSize: "",
      intResult: "",
      pms: {
        cemeteryUse: false,
        qrCode: false,
        posterse: false,
        freezingSpace: false,
        change: false,
        uploading: false,
        claimCode: false,
        claimCodeApp: false,
        claimCodeAll: false,
        lifeAlbum: false,
      },
      cemeteryText: "",
      cemeteryUseDialog: false,

      toShowCover: true,
      timer: null,
      totleTime: 60,
      timerUpdate: null,
      totleTimeUpdate: 60,
      timerClock: null,
      totleTimeClock: 60,
      editor1: null,
      //editor2: null,
      editor1TextLength: 0,
      //editor2TextLength: 0,
      clock: true,
      fileCover: "",
      //fileCoverBig: "",
      isCanClick: false,
      textWithoutNbsp1: "",
      textWithoutNbsp2: "",
      canType: false,
      scrollDiv: "",
      isNeedChangeMusic: false,
      isAllUpdateOk: false,
      updateNum: 0,
      //keyList: [],
      tableLog: false,

      updateListIndex: 0,

      calendarDialog: false,

      calendarType: 0,

      dateNow: '',
      lifeTitle1: '',
      // 当前生平模板
      curr_leftstory_temp_index:-1,
      lifestory_change_to_template:false,
    };
  },
  computed: {
    isCanNext: {
      get: function () {
        return this.SpaceManagement.spaceDetails.isCanNext;
      },
      set: function (v) {
        this.ISCANNEXT(v);
      },
    },
    photoAlbumDetails: {
      get: function () {
        return this.SpaceManagement.spaceDetails.photoAlbumDetails;
      },
      set: function (v) {
        this.PHOTOALBUMDETAILS(v);
      },
    },
    photoAlbumData: {
      get: function () {
        return this.SpaceManagement.spaceDetails.photoAlbumData;
      },
      set: function (v) {
        this.PHOTOALBUMDATA(v);
      },
    },
    photoAlbumDialog: {
      get: function () {
        return this.SpaceManagement.spaceDetails.photoAlbumDialog;
      },
      set: function (v) {
        this.PHOTOALBUMDIALOG(v);
      },
    },
    showOrdown: {
      get: function () {
        return this.SpaceManagement.spaceDetails.showOrdown;
      },
      set: function (v) {
        this.TOSHOWPOSTER(v);
      },
    },
    showBgUrl: {
      get: function () {
        return this.SpaceManagement.spaceDetails.showBgUrl;
      },
      set: function (v) {
        this.TOSHOWBGURL(v);
      },
    },
    fontColor: {
      get: function () {
        return this.SpaceManagement.spaceDetails.fontColor;
      },
      set: function (v) {
        this.FONTCOLOR(v);
      },
    },
    qrcodeVisible: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisible;
      },
      set: function (v) {
        this.SETQRCODEVISIBLE(v);
      },
    },
    qrcodeVisibleClaimApp: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleClaimApp;
      },
      set: function (v) {
        this.SETQRCODEVISIBLECLAIMAPP(v);
      },
    },
    qrcodeVisibleClaimAll: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleClaimAll;
      },
      set: function (v) {
        this.SETQRCODEVISIBLECLAIMALL(v);
      },
    },
    qrcodeVisibleClaim: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleClaim;
      },
      set: function (v) {
        this.SETQRCODEVISIBLECLAIM(v);
      },
    },
    qrcodeVisibleDownClaimApp: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleDownClaimApp;
      },
      set: function (v) {
        this.SETQRCODEVISIBLEDOWNCLAIMAPP(v);
      },
    },
    qrcodeVisibleDownClaimAll: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleDownClaimAll;
      },
      set: function (v) {
        this.SETQRCODEVISIBLEDOWNCLAIMALL(v);
      },
    },
    qrcodeVisibleDown: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleDown;
      },
      set: function (v) {
        this.SETQRCODEVISIBLEDOWN(v);
      },
    },
    qrcodeVisibleDownClaim: {
      get: function () {
        return this.SpaceManagement.spaceDetails.qrcodeVisibleDownClaim;
      },
      set: function (v) {
        this.SETQRCODEVISIBLEDOWNCLAIM(v);
      },
    },
    showOrdownCode: {
      get: function () {
        return this.SpaceManagement.spaceDetails.showOrdownCode;
      },
      set: function (v) {
        this.TOSHOWPOSTERCODE(v);
      },
    },
    showBgUrlCode: {
      get: function () {
        return this.SpaceManagement.spaceDetails.showBgUrlCode;
      },
      set: function (v) {
        this.TOSHOWBGURLCODE(v);
      },
    },
    fontColorCode: {
      get: function () {
        return this.SpaceManagement.spaceDetails.fontColorCode;
      },
      set: function (v) {
        this.FONTCOLORCODE(v);
      },
    },
    drawarWidth() {
      let result = 130.0 * this.docFontSize;
      let percent = (result / document.body.clientWidth) * 100;
      return `${percent}%`;
    },
    spaceLogForm() {
      return this.SpaceManagement.spaceDetails.spaceLogForm;
    },
    numberLog: {
      get: function () {
        return this.SpaceManagement.spaceDetails.numberLog;
      },
      set: function (v) {
        this.SETLOGNUMBERDETAILS(v);
      },
    },
    logList() {
      return this.SpaceManagement.spaceDetails.logList;
    },
    pageManagementLog() {
      return this.SpaceManagement.spaceDetails.pageManagementLog;
    },
    details() {
      return this.SpaceManagement.spaceDetails.details;
    },
    spaceHomeForm() {
      return this.SpaceManagement.spaceDetails.spaceHomeForm;
    },
    stateList() {
      return this.SpaceManagement.spaceDetails.stateList;
    },
    calendarList() {
      return this.SpaceManagement.spaceDetails.calendarList;
    },
    updateState: {
      get: function () {
        return this.SpaceManagement.spaceDetails.updateState;
      },
      set: function (v) {
        this.SETUPDATE(v);
      },
    },
    isCanUpdate: {
      get: function () {
        return this.SpaceManagement.spaceDetails.isCanUpdate;
      },
      set: function (v) {
        this.SETCANUPDATE(v);
      },
    },
    uploadState: {
      get: function () {
        return this.SpaceManagement.spaceDetails.uploadState;
      },
      set: function (v) {
        this.SETUPLOAD(v);
      },
    },
    isHaveCover: {
      get: function () {
        return this.SpaceManagement.spaceDetails.isHaveCover;
      },
    },
    photoCategoryList() {
      return this.SpaceManagement.spaceDetails.photoCategoryList;
    },
    pageInfo: {
      get: function () {
        return this.SpaceManagement.spaceDetails.pageInfo;
      },
      set: function (v) {
        this.PAGEINFO(v);
      },
    },
    //上传数组
    updateFileList: {
      get: function () {
        return this.SpaceManagement.spaceDetails.updateFileList;
      },
      set: function (v) {
        this.UPDATEFILELIST(v);
      },
    },
    // 生平模板
    templateTableData() {
      return this.Unit.templateTableData;
    },
  },
  filters: {
    remarkLength(v) {
      if (v) {
        return v.length;
      } else {
        return 0;
      }
    },
  },
  created() {
    //处理返回键
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, document.URL);
    });

    if (
      JSON.parse(window.sessionStorage.getItem("binyi_cms_loginInfo"))
        .unitType == 2
    ) {
      this.canType = true;
    } else {
      this.canType = false;
    }

    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    //纪念堂管理-陵园使用
    this.pms.cemeteryUse = pms["51009"].check;
    //纪念堂管理-详情-访问码预览/下载
    this.pms.qrCode = pms["51001"].check;
    //纪念堂管理-详情-海报预览/下载
    this.pms.posterse = pms["51003"].check;
    //纪念堂管理-详情-冻结纪念堂
    this.pms.freezingSpace = pms["51005"].check;
    //解除冻结纪念堂
    this.pms.relieveS = pms["50700"].check;
    //纪念堂管理-详情-保存/获取操作权限验证码/修改
    this.pms.change = pms["51007"].check;
    //纪念堂管理-详情-上传
    this.pms.uploading = pms["51008"].check;
    //认领码
    this.pms.claimCode = pms["51010"].check;
    //认领码APP
    this.pms.claimCodeApp = pms["51011"].check;
    //认领码All
    this.pms.claimCodeAll = pms["51012"].check;
    //纪念堂管理-人生相册
    this.pms.lifeAlbum = pms["51013"].check;

    this.isCanClick = !JSON.parse(
      window.sessionStorage.getItem("binyi_cms_loginInfo")
    ).validateRole;
    // 生平模板
    this.getTemplateAllList_A();
    
    this.refresh(true, "");
  },
  mounted() {
    this.setLeftMenuShow_M(false);
    //获取节点
    this.scrollDiv = document.getElementById("scrollDiv");
    //绑定事件
    scrollDiv.addEventListener("scroll", this.scrollBackTop);
    this.editor1 = new E(this.$refs.editorElem1);

    // 编辑器的事件，每次改变会获取其html内容
    this.editor1.config.onchange = (html) => {
      console.log(html);
      if(this.lifestory_change_to_template ) {
      this.lifestory_change_to_template = false;
      } else if(this.curr_leftstory_temp_index != -1){
        this.curr_leftstory_temp_index = -1

      }
      if (this.editor1.txt.text().replace(/&nbsp;/g, "").length > 20100) {
        this.editor1.txt.html(
          this.SpaceManagement.spaceDetails.details.lifeStory1
        );
      } else {
        this.SpaceManagement.spaceDetails.details.lifeStory1 = html;
        let textWithnbsp = this.editor1.txt.text();
        this.textWithoutNbsp1 = textWithnbsp.replace(/&nbsp;/g, "");
        this.editor1TextLength = this.textWithoutNbsp1.length;
      }
    };

    this.editor1.config.menus = [
      // 菜单配置
      "bold",
      "underline",
      "lineHeight",
      "justify",
      "customIndent",
      "undo",
      "redo",
    ];
    const menuKey1 = ""; // 菜单 key ，各个菜单不能重复
    this.editor1.menus.extend("customIndent", AlertMenu);

    // 将菜单加入到 editor.config.menus 中
    // 也可以通过配置 menus 调整菜单的顺序，参考【配置菜单】部分的文档
    this.editor1.config.menus = this.editor1.config.menus.concat(menuKey1);
    this.editor1.config.showFullScreen = false;
    this.editor1.config.focus = false;
    this.editor1.config.placeholder = "";
    this.editor1TextLength = 0;


    let date = new Date()
    let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

    this.dateNow = date.getFullYear() + '-' + month + '-' + day
    console.log(this.dateNow)
  },

  //移除滚动条监听
  destroyed() {
    scrollDiv.removeEventListener("scroll", this.scrollBackTop);
  },

  watch: {
    // photoAlbumDetails: function (v) {
    //   let that = this
    //   if (!v.show) {
    //     setTimeout(() => {
    //       scrollDiv.scrollTo({
    //         top: that.scrollTop,
    //         behavior: "smooth",
    //       });
    //     }, 100)
    //   }
    // },
  },

  methods: {
    toShowCalendar(type) {
      let date = new Date()
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.dateNow = date.getFullYear() + '-' + month + '-' + day
      console.log(this.dateNow)
      this.calendarType = type;
      this.calendarDialog = true;
    },
    deleteCalendar(type) {
      if (type == 1) {
        this.SpaceManagement.spaceDetails.spaceHomeForm.birthday = '';
        this.SpaceManagement.spaceDetails.spaceHomeForm.birthdaySolar = '';
        this.SpaceManagement.spaceDetails.spaceHomeForm.birthdayLunar = '';
      } else {
        this.SpaceManagement.spaceDetails.spaceHomeForm.deadday = '';
        this.SpaceManagement.spaceDetails.spaceHomeForm.deaddaySolar = '';
        this.SpaceManagement.spaceDetails.spaceHomeForm.deaddayLunar = '';
      }
    },
    changeCalendar() {
      if (this.SpaceManagement.spaceDetails.spaceHomeForm.calendarState == 1) {
        //公
        if (this.SpaceManagement.spaceDetails.spaceHomeForm.birthday != undefined) {
          this.SpaceManagement.spaceDetails.spaceHomeForm.birthday =
            this.SpaceManagement.spaceDetails.spaceHomeForm.birthdaySolar
        }
        if (this.SpaceManagement.spaceDetails.spaceHomeForm.deadday != undefined) {
          this.SpaceManagement.spaceDetails.spaceHomeForm.deadday =
            this.SpaceManagement.spaceDetails.spaceHomeForm.deaddaySolar
        }
      } else {
        if (this.SpaceManagement.spaceDetails.spaceHomeForm.birthday != undefined) {
          if (this.SpaceManagement.spaceDetails.spaceHomeForm.birthdayLunar == undefined ||
            this.SpaceManagement.spaceDetails.spaceHomeForm.birthdayLunar == '') {
            let lunar = calendar.solar2lunar(
              this.SpaceManagement.spaceDetails.spaceHomeForm.birthdaySolar.substring(0, 4),
              this.SpaceManagement.spaceDetails.spaceHomeForm.birthdaySolar.substring(5, 7),
              this.SpaceManagement.spaceDetails.spaceHomeForm.birthdaySolar.substring(8, 10))
            this.SpaceManagement.spaceDetails.spaceHomeForm.birthdayLunar = lunar.gzYear + lunar.Animal + '年' + lunar.IMonthCn + lunar.IDayCn
          }
          this.SpaceManagement.spaceDetails.spaceHomeForm.birthday =
            this.SpaceManagement.spaceDetails.spaceHomeForm.birthdayLunar
        }
        if (this.SpaceManagement.spaceDetails.spaceHomeForm.deadday != undefined) {
          if (this.SpaceManagement.spaceDetails.spaceHomeForm.deaddayLunar == undefined ||
            this.SpaceManagement.spaceDetails.spaceHomeForm.deaddayLunar == '') {
            let lunar = calendar.solar2lunar(
              this.SpaceManagement.spaceDetails.spaceHomeForm.deaddaySolar.substring(0, 4),
              this.SpaceManagement.spaceDetails.spaceHomeForm.deaddaySolar.substring(5, 7),
              this.SpaceManagement.spaceDetails.spaceHomeForm.deaddaySolar.substring(8, 10))
            this.SpaceManagement.spaceDetails.spaceHomeForm.deaddayLunar = lunar.gzYear + lunar.Animal + '年' + lunar.IMonthCn + lunar.IDayCn
          }
          this.SpaceManagement.spaceDetails.spaceHomeForm.deadday =
            this.SpaceManagement.spaceDetails.spaceHomeForm.deaddayLunar
        }
      }
    },
    updateLunar(data) {
      console.log(data)
      let lunar = data.lYear + data.Animal + '年' + data.IMonthCn + data.IDayCn
      let month = data.month < 10 ? '0' + data.month : data.month
      let day = data.day < 10 ? '0' + data.day : data.day
      let solar = data.year + "-" + month + "-" + day
      if (this.calendarType == 1) {
        //生
        this.SpaceManagement.spaceDetails.spaceHomeForm.birthdayLunar = lunar
        this.SpaceManagement.spaceDetails.spaceHomeForm.birthdaySolar = solar
        if (this.SpaceManagement.spaceDetails.spaceHomeForm.calendarState == 1) {
          //公
          this.SpaceManagement.spaceDetails.spaceHomeForm.birthday = solar
        } else {
          this.SpaceManagement.spaceDetails.spaceHomeForm.birthday = lunar
        }
      } else {
        //忌
        this.SpaceManagement.spaceDetails.spaceHomeForm.deaddayLunar = lunar
        this.SpaceManagement.spaceDetails.spaceHomeForm.deaddaySolar = solar
        if (this.SpaceManagement.spaceDetails.spaceHomeForm.calendarState == 1) {
          //公
          this.SpaceManagement.spaceDetails.spaceHomeForm.deadday = solar
        } else {
          this.SpaceManagement.spaceDetails.spaceHomeForm.deadday = lunar
        }
      }
      this.calendarDialog = false
    },
    choicePhotoDetails(index) {
      if (this.uploadState) {
        return
      }
      this.photoAlbumDetails = {
        show: true,
        name: this.photoCategoryList[index].name,
        categoryId: this.photoCategoryList[index].id,
      }
      this.isCanUpdate = true
      let params = {}
      params.data = {
        dmId: this.$route.query.id,
        categoryId: this.photoCategoryList[index].id,
      }
      this.pageInfo = {
        page: 1,
        size: 50,
        total: 0
      }
      params.pageInfo = this.pageInfo
      this.findPhotoByCategoryId(params).then((res) => {
        console.log(res)
        if (res.status == 1000) {
          if (res.data.length < 50) {
            this.isCanNext = false;
          } else {
            this.isCanNext = true;
          }
          res.data.forEach(item => {
            item.isUpdate = 3;
            if (item.type == 2) {
              item.seconds = seconds.getSecond(Math.round(item.second));
            }
          })
          this.updateFileList = res.data;
        } else if (res.status == 1098) {
          this.showCo();
        }
      })
    },
    toShowItem(index) {
      if (this.uploadState) {
        return
      }
      this.photoCategoryList[index].show = !this.photoCategoryList[index].show;
      this.photoCategoryList.forEach((item, i) => {
        if (i != index) {
          item.show = false;
        }
      })
    },
    toHidePhotoAlbum() {
      this.photoCategoryList.forEach((item, i) => {
        item.show = false;
      });
      this.$refs.spaceLifeAlbumRef.closePhotoOptions();
    },
    deleteAlbum(item) {
      let htmlStr = `<div>确定要删除<span style='color:#4EA2FF;font-size:2rem;'> ${item.name} </span>相册吗？删除后该相册中的所有照片/视频均将删除，不可找回，是否删除</div>`;
      this.$Confirm(htmlStr, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          let params = {
            dmId: this.$route.query.id,
            categoryId: item.id
          }
          this.delPhotoCategory(params).then((res) => {
            console.log(res)
            if (res.status == 1000) {
              this.$message.success("操作成功");
              this.findPhotoCategory(this.SpaceManagement.spaceDetails.details.id);
              this.findByIdAnother(this.SpaceManagement.spaceDetails.details.id).then((res) => {
                if (res.status == 1000) {
                  if (res.data.fileVideoSizeUse == 0) {
                    this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = 0
                  } else {
                    this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = res.data.fileVideoSizeUse / res.data.fileSizeCount * 100
                    if (this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef < 1) {
                      this.SpaceManagement.spaceDetails.details.fileVideoSizeUsef = 1
                    }
                  }
                  if (res.data.filePicSizeUse == 0) {
                    this.SpaceManagement.spaceDetails.details.filePicSizeUsef = 0
                  } else {
                    this.SpaceManagement.spaceDetails.details.filePicSizeUsef = res.data.filePicSizeUse / res.data.fileSizeCount * 100
                    if (this.SpaceManagement.spaceDetails.details.filePicSizeUsef < 1) {
                      this.SpaceManagement.spaceDetails.details.filePicSizeUsef = 1
                    }
                  }
                  this.SpaceManagement.spaceDetails.details.fileSizeUse =
                    res.data.fileSizeUse;
                  this.SpaceManagement.spaceDetails.details.fileSizeCount =
                    res.data.fileSizeCount;
                  this.SpaceManagement.spaceDetails.details.fileSizeUseA =
                    roundAll.roundFn(res.data.fileSizeUse / 1024 / 1024, 3);
                  this.SpaceManagement.spaceDetails.details.fileSizeCountA =
                    roundAll.roundFn(
                      res.data.fileSizeCount / 1024 / 1024 -
                      res.data.fileSizeUse / 1024 / 1024,
                      3
                    );
                  this.SpaceManagement.spaceDetails.details.fileVideoCount =
                    res.data.fileVideoCount;
                  this.SpaceManagement.spaceDetails.details.filePicCount =
                    res.data.filePicCount;
                  this.SpaceManagement.spaceDetails.details.viewCount =
                    res.data.viewCount;
                  if (res.data.uploadState == 1) {
                    this.uploadState = false;
                  } else {
                    this.uploadState = true;
                  }
                  this.SpaceManagement.spaceDetails.details.claimState =
                    res.data.claimState;
                } else if (res.status == 1098) {
                  this.showCo();
                }
              });
            } else if (res.status == 1098) {
              this.showCo();
            } else if (res.status == 1086) {
              this.$message.error(res.message);
            } else if (res.status == 1111) {
              this.$message.error('不能删除包含历史数据或用户上传内容的相册');
            }
          });
        })
        .catch(() => { });
    },
    setPhotoAlbum(index) {
      this.getUserCount(this.$route.query.id).then((res) => {
        if (res.status == 1000) {
          this.photoAlbumData = {
            id: this.photoCategoryList[index].id,
            name: this.photoCategoryList[index].name,
            lookPms: this.photoCategoryList[index].showScope,
            coverUrl: this.photoCategoryList[index].coverAuto == 0 ? this.photoCategoryList[index].coverUrl : '',
            source: this.photoCategoryList[index].source,
            photoCreated: false,
            number: res.data,
          };
          this.photoAlbumDialog = true;
        } else if (res.status == 1098) {
          this.showCo();
        }
      })
    },
    toCreatedPhotoAlbum() {
      this.getUserCount(this.$route.query.id).then((res) => {
        if (res.status == 1000) {
          this.photoAlbumData = {
            name: "",
            lookPms: '3',
            coverUrl: "",
            photoCreated: true,
            number: res.data,
          };
          this.photoAlbumDialog = true;
        } else if (res.status == 1098) {
          this.showCo();
        }
      })
    },
    //只更新头部
    refreshHalf(number) {
      this.findByIdHalf(this.$route.query.id).then((res) => {
        if (res.status == 1000) {
          if (number == 1) {
            this.cemeteryUseDialog = false;
          } else if (number == 4) {
            this.phoneClockDialog = false;
          }
        } else if (res.status == 1098) {
          this.showCo();
        }
      });
    },
    //整体刷新
    refresh(isFirst, isMoreP) {
      this.findById(this.$route.query.id).then((res) => {
        if (res.status == 1000) {
          document.title = res.data.name;

          this.TemplateSettingsFromData.bgId = res.data.bgId;
          this.TemplateSettingsFromData.msId = res.data.msId;
          // y-->
          this.fileCover = "";
          // <--y
          if (isFirst) {
            this.editor1.create(); // 创建富文本实例」
            //this.editor2.create(); // 创建富文本实例」
          }

          if (res.data.updateState == 1) {
            this.editor1.enable();
          } else {
            this.editor1.disable();
          }

          // if (res.data.updateState == 1) {
          //   this.editor2.enable();
          // } else {
          //   this.editor2.disable();
          // }

          if (isMoreP == "1") {
            if (res.data.updateState == 2) {
              this.$message.error(
                "已有工作人员(" +
                res.data.updateUserName +
                "," +
                res.data.updateUserTel +
                ")在操作，请等待操作结束后，再获取验证码"
              );
            } else if (res.data.updateState == 0) {
              this.message = "";
              this.phoneDialog = true;
            }
          }

          if (res.data.lifeTitle1 != undefined && res.data.lifeTitle1 != "") {
            this.lifeTitle1 = res.data.lifeTitle1
          } else {
            this.lifeTitle1 = '个人生平'
          }

          let contentZoarium = "";
          // if (res.data.lifeTitle1 != undefined && res.data.lifeTitle1 != "") {
          //   contentZoarium =
          //     '<p style="text-align:center;">' + res.data.lifeTitle1 + "</p>";
          // }
          if (res.data.lifeStory1 != undefined && res.data.lifeStory1 != "") {
            contentZoarium = contentZoarium + res.data.lifeStory1;
          }
          // if (res.data.lifeTitle2 != undefined && res.data.lifeTitle2 != "") {
          //   contentZoarium =
          //     contentZoarium +
          //     '<p style="text-align:center;">' +
          //     res.data.lifeTitle2 +
          //     "</p>";
          // }
          // if (res.data.lifeStory2 != undefined && res.data.lifeStory2 != "") {
          //   contentZoarium = contentZoarium + res.data.lifeStory2;
          // }
          this.SpaceManagement.spaceDetails.details.lifeStory1 = contentZoarium;
          this.editor1.txt.html(contentZoarium);

          //this.editor1.txt.html(res.data.lifeStory1 ? res.data.lifeStory1 : "");
          //this.editor2.txt.html(res.data.lifeStory2 ? res.data.lifeStory2 : "");
          //this.findAllBgTemplate()

          //获取模板
          this.getAllBgTemplateV2();
          
          this.findAllMusicTemplate().then((resb) => {
            console.log(resb);
            resb.data.forEach((item) => {
              item.isPlay = false;
            });
            this.imgListMusic = resb.data;
            if (!this.TemplateSettingsFromData.msId) {
              this.TemplateSettingsFromData.msId = this.imgListMusic[0].id;
              this.indexMusic = 0;
            } else {
              this.imgListMusic.forEach((item, index) => {
                if (item.id == this.TemplateSettingsFromData.msId) {
                  this.indexMusic = index;
                }
              });
            }
          });

          this.findPhotoCategory(this.$route.query.id)

        } else if (res.status == 1098) {
          this.showCo();
        }
      });
      //this.findUserDmRelationById(this.$route.query.id);
      //this.findSignInById(this.$route.query.id);
    },

    refreshMiddle() {
      this.findByIdMiddle(this.$route.query.id).then((res) => {
        if (res.status == 1000) {
          document.title = res.data.name;

          this.TemplateSettingsFromData.bgId = res.data.bgId;
          this.TemplateSettingsFromData.msId = res.data.msId;
          // y-->
          this.fileCover = "";
          // <--y

          if (res.data.updateState == 1) {
            this.editor1.enable();
          } else {
            this.editor1.disable();
          }

          if (res.data.lifeTitle1 != undefined && res.data.lifeTitle1 != "") {
            this.lifeTitle1 = res.data.lifeTitle1
          } else {
            this.lifeTitle1 = '个人生平'
          }

          let contentZoarium = "";
          if (res.data.lifeStory1 != undefined && res.data.lifeStory1 != "") {
            contentZoarium = contentZoarium + res.data.lifeStory1;
          }
          this.SpaceManagement.spaceDetails.details.lifeStory1 = contentZoarium;
          this.editor1.txt.html(contentZoarium);

          //获取模板
          this.getAllBgTemplateV2();
          
          this.findAllMusicTemplate().then((resb) => {
            console.log(resb);
            resb.data.forEach((item) => {
              item.isPlay = false;
            });
            this.imgListMusic = resb.data;
            if (!this.TemplateSettingsFromData.msId) {
              this.TemplateSettingsFromData.msId = this.imgListMusic[0].id;
              this.indexMusic = 0;
            } else {
              this.imgListMusic.forEach((item, index) => {
                if (item.id == this.TemplateSettingsFromData.msId) {
                  this.indexMusic = index;
                }
              });
            }
          });

        } else if (res.status == 1098) {
          this.showCo();
        }
      });
    },
    // 选择生平模板
    btn_lifestory_template_Click(index,disable) {
      if(this.curr_leftstory_temp_index != index && !disable) {


        this.$Confirm("是否要替换生平内容为所选中的模板", "提示", {
        type: "warning"
      })
        .then(() => {
          this.curr_leftstory_temp_index = index;
        var template = this.templateTableData[index];
        this.lifestory_change_to_template = true;
        this.editor1.txt.html(template.lifeStory)
        })
        .catch(() => {
        });


        
      }
    },
    getBGname(val) {
      if (this.listArr.length) {
        let item = this.listArr.find(function (x) {
          return x.id == val;
        });
        if (item) return item.name;
        return "";
      }
    },

    getBGMname(val) {
      if (this.imgListMusic.length) {
        let item = this.imgListMusic.find(function (x) {
          return x.id == val;
        });
        if (item) return item.name;
        return "";
      }
    },
    playAudio(url, index, id) {
      if (this.updateState) {
        return;
      }
      if (this.indexMusic != index) {
        this.indexMusic = index;
        this.TemplateSettingsFromData.msId = id;
        this.imgListMusic.forEach((item) => {
          if (item.isPlay) {
            item.isPlay = false;
          }
        });
        document.getElementById("audioMusic").pause();
        this.isNeedChangeMusic = true;
        return;
      }
      this.audioMusicPath = url;
      if (this.isNeedChangeMusic) {
        this.isNeedChangeMusic = false;
        document.getElementById("audioMusic").load();
      }
      this.playAudioLoad();
      this.imgListMusic[index].isPlay = true;
    },
    async playAudioLoad() {
      try {
        await document.getElementById("audioMusic").play();
      } catch (e) {
        setTimeout(this.playAudioLoad, 500);
      }
    },
    pauseAudio(index) {
      document.getElementById("audioMusic").pause();
      this.imgListMusic[index].isPlay = false;
    },

    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        scrollDiv.scrollTop = scrollDiv.scrollTop = that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollBackTop() {
      const that = this;
      let scrollTop = scrollDiv.scrollTop;
      //that.scrollTop = scrollTop;
      // if (that.scrollTop > 500) {
      //   that.showIcon = true;
      // } else {
      //   that.showIcon = false;
      // }

      if (this.$refs.lifeAlbumRef.getBoundingClientRect().top <= 700) {
        if (this.titleNumber != 5) {
          this.titleNumber = 5;
        }
      } else if (this.$refs.obtainC.getBoundingClientRect().top <= 600) {
        if (this.titleNumber != 4) {
          this.titleNumber = 4;
        }
      } else if (this.$refs.obtainA.getBoundingClientRect().top <= 500) {
        if (this.titleNumber != 2) {
          this.titleNumber = 2;
        }
      } else if (that.scrollTop >= 0) {
        if (this.titleNumber != 1) {
          this.titleNumber = 1;
        }
      } else {
        this.titleNumber = 1;
      }
    },
    handleCurrentChange(v) {
      console.log(v);
      this.findSignInById(this.$route.query.id);
    },
    handleSizeChange(v) {
      console.log(v);
    },
    toGoPage(number) {
      let name = "";
      if (number == 1) {
        name = ".space_details_title";
      } else if (number == 2) {
        name = ".space_change_all_title";
      } else if (number == 4) {
        name = ".visitors_to_code_s";
      } else if (number == 5) {
        name = ".lifeAlbum_body";
      }
      let fjfwBox = document.querySelector(name);
      scrollDiv.scrollTo({
        top: fjfwBox.offsetTop,
        behavior: "smooth",
      });
    },
    //上传封面
    coverFileInfo(file) {
      console.log(file);
      this.fileCover = file[0];
      //this.fileCoverBig = file[1];
      this.SpaceManagement.spaceDetails.details.coverUrl = file[0].url;
      this.toShowCover = !this.toShowCover;
    },

    //背景模板
    choiceBack(number, id) {
      if (this.updateState) {
        return;
      }
      this.TemplateSettingsFromData.bgId = id;
      this.indexBack = number;
    },

    //音乐模板
    choiceMusic(number, id) {
      if (this.updateState) {
        return;
      }
      this.TemplateSettingsFromData.msId = id;
      document.getElementById("audioMusic").pause();
      if (this.indexMusic != number) {
        this.isNeedChangeMusic = true;
        this.indexMusic = number;
      }
      this.imgListMusic.forEach((item) => {
        if (item.isPlay) {
          item.isPlay = false;
        }
      });
    },

    //访问码
    toShowQRCode() {
      this.qrcodeVisible = true;
    },

    exportQrcodePicTimerAnother() {
      this.qrcodeVisibleDown = true;
    },

    //海报
    toShowPoster(bgUrl,fontColor) {
      this.showBgUrl = bgUrl;
      this.fontColor = fontColor;
      this.showOrdown = 1;
    },

    downImage(bgUrl,fontColor) {
      this.showBgUrl = bgUrl;
      this.fontColor = fontColor;
      this.showOrdown = 2;
    },

    //竖版
    toShowClaimCode(bgUrl,fontColor) {
      this.showBgUrlCode = bgUrl;
      this.fontColorCode = fontColor;
      this.showOrdownCode = 1;
    },

    downImageClaimCode(bgUrl,fontColor) {
      this.showBgUrlCode = bgUrl;
      this.fontColorCode = fontColor;
      this.showOrdownCode = 2;
    },

    // downImageVertical() {
    //   this.showOrdown = 3;
    // },

    //认领码
    toShowQRCodeClaim() {
      this.qrcodeVisibleClaim = true;
    },

    exportQrcodePicTimerAnotherClaimApp() {
      this.qrcodeVisibleDownClaimApp = true;
    },

    exportQrcodePicTimerAnotherClaim() {
      this.qrcodeVisibleDownClaim = true;
    },

    exportQrcodePicTimerAnotherClaimAll() {
      this.qrcodeVisibleDownClaimAll = true;
    },

    //获取验证码
    getPhoneMessage() {
      this.refresh(false, "1");
    },

    getPhoneMessageClock() {
      this.clock = true;
      this.messageClock = "";
      this.freezeRemark = "";
      this.phoneClockDialog = true;
    },

    getPhoneMessageClockA() {
      this.clock = false;
      this.messageClock = "";
      this.phoneClockDialog = true;
    },

    //上传操作验证码
    getPhoneMessageUpdate() {
      this.findByIdAnother(this.$route.query.id).then((res) => {
        if (res.status == 1000) {
          if (res.data.uploadState == 2) {
            this.$message.error(
              "已有工作人员(" +
              res.data.uploadUserName +
              "," +
              res.data.uploadUserTel +
              ")在操作，请等待操作结束后，再获取验证码"
            );
          } else if (res.data.uploadState == 0) {
            this.messageUpdate = "";
            this.phoneUpdateDialog = true;
          }
        } else if (res.status == 1098) {
          this.showCo();
        }
      });
    },

    handlePhoneClose(done) {
      this.message = "";
      window.clearInterval(this.timer);
      this.timer = null;
      this.totleTime = 60;
      done();
    },

    handlePhoneUpdateClose(done) {
      this.messageUpdate = "";
      window.clearInterval(this.timerUpdate);
      this.timerUpdate = null;
      this.totleTimeUpdate = 60;
      done();
    },

    handlePhoneClockClose(done) {
      this.messageClock = "";
      window.clearInterval(this.timerClock);
      this.timerClock = null;
      this.totleTimeClock = 60;
      done();
    },

    handleCalendarClose(done) {
      done();
    },

    dialogCalendarCancel() {
      this.calendarDialog = false;
    },

    dialogCalendarSave() {
      this.calendarDialog = false;
    },

    dialogPhoneCancel() {
      this.phoneDialog = false;
      this.message = "";
      window.clearInterval(this.timer);
      this.timer = null;
      this.totleTime = 60;
    },

    dialogPhoneUpdateCancel() {
      this.phoneUpdateDialog = false;
      this.messageUpdate = "";
      window.clearInterval(this.timerUpdate);
      this.timerUpdate = null;
      this.totleTimeUpdate = 60;
    },

    dialogPhoneClockCancel() {
      this.phoneClockDialog = false;
      this.messageClock = "";
      window.clearInterval(this.timerClock);
      this.timerClock = null;
      this.totleTimeClock = 60;
    },

    dialogPhoneSave() {
      if (this.message == "") {
        this.$message.error("请输入验证码");
        return;
      }
      let params = {
        id: this.$route.query.id,
        code: this.message,
      };
      this.editUpdateStateById(params).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("获取成功");
          this.phoneDialog = false;
          window.clearInterval(this.timer);
          this.timer = null;
          this.totleTime = 60;
          this.refresh(false, "");
        } else if (res.status == 1018) {
          this.$message.error("验证码已失效");
        } else if (res.status == 1019) {
          this.$message.error("验证码错误");
        } else if (res.status == 1098) {
          this.showCo();
        } else {
          this.$message.error("获取失败");
        }
      });
    },

    dialogPhoneUpdateSave() {
      if (this.messageUpdate == "") {
        this.$message.error("请输入验证码");
        return;
      }
      let params = {
        id: this.$route.query.id,
        code: this.messageUpdate,
      };
      this.editUploadStateById(params).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("获取成功");
          window.clearInterval(this.timerUpdate);
          this.timerUpdate = null;
          this.totleTimeUpdate = 60;
          this.findByIdAnother(this.$route.query.id).then((resb) => {
            if (resb.status == 1000) {
              if (resb.data.uploadState == 1) {
                this.uploadState = false;
                this.findPhotoCategory(this.$route.query.id);
              } else {
                this.uploadState = true;
              }
              this.phoneUpdateDialog = false;
            } else if (resb.status == 1098) {
              this.showCo();
            }
          });
        } else if (res.status == 1018) {
          this.$message.error("验证码已失效");
        } else if (res.status == 1019) {
          this.$message.error("验证码错误");
        } else if (res.status == 1098) {
          this.showCo();
        } else {
          this.$message.error("获取失败");
        }
      });
    },

    dialogPhoneClockSave(isFreeze) {
      if (this.freezeRemark == "" && isFreeze) {
        this.$message.error("请输入冻结纪念堂理由");
        return;
      }
      if (this.messageClock == "") {
        this.$message.error("请输入验证码");
        return;
      }

      let params = {
        id: this.$route.query.id,
        status: this.clock ? 1 : 4, //1冻结， 4解冻
        code: this.messageClock,
        remark: this.freezeRemark,
      };
      this.editSpaceFrozenById(params).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.messageClock = "";
          if (this.clock) {
            this.$message.success("纪念堂冻结成功");
          } else {
            this.$message.success("纪念堂解冻成功");
          }
          window.clearInterval(this.timerClock);
          this.timerClock = null;
          this.totleTimeClock = 60;
          this.refreshHalf(4);
        } else if (res.status == 1018) {
          this.$message.error("验证码不正确，请输入正确的验证码");
        } else if (res.status == 1019) {
          this.$message.error("验证码不正确，请输入正确的验证码");
        } else if (res.status == 1098) {
          this.showCo();
        } else {
          this.$message.error("验证码不正确，请输入正确的验证码");
        }
      });
    },

    //陵园使用
    cemeteryUse() {
      this.cemeteryText = this.SpaceManagement.spaceDetails.details.cemetery;
      this.cemeteryUseDialog = true;
    },

    handleCemeteryClose(done) {
      this.cemeteryText = "";
      done();
    },

    dialogCemeterySave() {
      this.editCemeteryById({
        id: this.$route.query.id,
        cemetery: this.cemeteryText,
      }).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("陵园使用成功");
          this.cemeteryText = "";
          this.refreshHalf(1);
        } else if (res.status == 1098) {
          this.showCo();
        }
      });
    },

    dialogCemeteryCancel() {
      this.cemeteryText = "";
      this.cemeteryUseDialog = false;
    },

    async getMessage() {
      let data = this.SpaceManagement.spaceDetails.details.id;
      let [err, res] = await catchErr(
        _editUpdateStateSendCode(
          {
            data: data,
          },
          this.SpaceManagement.spaceDetails.details.id
        )
      );
      console.log(err);
      if (err) {
        if (err.status == 1081) {
          this.$message.error(err.message);
          return;
        } else if (err.status == 1066) {
          this.$message.error("纪念堂没有主办人");
          return;
        } else if (err.status == 1098) {
          this.showCo();
          return;
        }
        this.$message.error(err.message || "发送失败");
      } else {
        console.log(res);
        this.$message.success("发送成功");
        this.timer = window.setInterval(() => {
          this.totleTime--;
          if (this.totleTime <= 0) {
            window.clearInterval(this.timer);
            this.timer = null;
            this.totleTime = 60;
          }
        }, 1000);
      }
    },

    async getMessageUpdate() {
      let data = this.SpaceManagement.spaceDetails.details.id;
      let [err, res] = await catchErr(
        _editUploadStateSendCode(
          {
            data: data,
          },
          this.SpaceManagement.spaceDetails.details.id
        )
      );
      console.log(err);
      if (err) {
        if (err.status == 1081) {
          this.$message.error(err.message);
          return;
        } else if (err.status == 1066) {
          this.$message.error("纪念堂没有主办人");
          return;
        } else if (err.status == 1098) {
          this.showCo();
          return;
        }
        this.$message.error(err.message || "发送失败");
      } else {
        console.log(res);
        this.$message.success("发送成功");
        this.timerUpdate = window.setInterval(() => {
          this.totleTimeUpdate--;
          if (this.totleTimeUpdate <= 0) {
            window.clearInterval(this.timerUpdate);
            this.timerUpdate = null;
            this.totleTimeUpdate = 60;
          }
        }, 1000);
      }
    },

    async getMessageClock() {
      let data = this.SpaceManagement.spaceDetails.details.id;
      let [err, res] = await catchErr(
        _editSpaceFrozenSendCode(
          {
            data: data,
          },
          this.SpaceManagement.spaceDetails.details.id
        )
      );
      if (err) {
        if (err.status == 1098) {
          this.showCo();
          return;
        }
        this.$message.error(err.message || "发送失败");
      } else {
        this.$message.success("发送成功");
        this.timerClock = window.setInterval(() => {
          this.totleTimeClock--;
          if (this.totleTimeClock <= 0) {
            window.clearInterval(this.timerClock);
            this.timerClock = null;
            this.totleTimeClock = 60;
          }
        }, 1000);
      }
    },

    //保存
    save(updateContinue) {
      let params = {};
      params.id = this.$route.query.id;
      let spaceNameNew = this.SpaceManagement.spaceDetails.spaceHomeForm.name;
      spaceNameNew = spaceNameNew.replace(/(^\s*)|(\s*$)/g, "");
      if (spaceNameNew == "" || spaceNameNew.length < 2) {
        this.$message.error("纪念堂名称不能为空");
        return;
      }
      params.name = spaceNameNew;
      params.gender = this.SpaceManagement.spaceDetails.spaceHomeForm.sex;
      params.calendarState = this.SpaceManagement.spaceDetails.spaceHomeForm.calendarState
      if (this.SpaceManagement.spaceDetails.spaceHomeForm.birthday != '') {
        params.birthday = this.SpaceManagement.spaceDetails.spaceHomeForm.birthdaySolar;
        params.birthdayLunar = this.SpaceManagement.spaceDetails.spaceHomeForm.birthdayLunar;
      }
      if (this.SpaceManagement.spaceDetails.spaceHomeForm.deadday != '') {
        params.deadday = this.SpaceManagement.spaceDetails.spaceHomeForm.deaddaySolar;
        params.deaddayLunar = this.SpaceManagement.spaceDetails.spaceHomeForm.deaddayLunar;
      }

      //遗像
      if (
        this.SpaceManagement.spaceDetails.details.coverUrl == undefined ||
        this.SpaceManagement.spaceDetails.details.coverUrl == ""
      ) {
        this.$message.error("纪念堂封面不能为空");
        return;
      }
      params.headUrl = this.SpaceManagement.spaceDetails.details.coverUrl;
      params.coverUrl = this.SpaceManagement.spaceDetails.details.coverUrl;

      if (this.lifeTitle1 == undefined || this.lifeTitle1 == "") {
        this.$message.error("纪念堂生平标题不能为空");
        return;
      }

      var re = /[\u4e00-\u9fa5]/;
      let number = 0
      for (let i = 0; i < this.lifeTitle1.length; i++) {
        let str = this.lifeTitle1.substring(i, i + 1)
        console.log(str)
        if (re.test(str)) {
          number = number + 2
        } else {
          number = number + 1
        }
      }
      if (number > 8) {
        this.$message.error("标题最多输入4个字");
        return;
      }

      params.lifeTitle1 = this.lifeTitle1

      if (this.textWithoutNbsp1 != "") {
        params.lifeStory1 =
          this.SpaceManagement.spaceDetails.details.lifeStory1;
      }

      if (this.indexBack == -1) {
        this.$message.error("请选择背景模板");
        return;
      }
      params.bgId = this.TemplateSettingsFromData.bgId;
      params.msId = this.TemplateSettingsFromData.msId;

      //let photoList = [];

      // if (this.fileCover != "") {
      //   photoList.push({
      //     photoUrl: this.fileCoverBig.url,
      //     type: 1,
      //     source: 2,
      //     size: parseInt(this.fileCoverBig.size / 1024),
      //   });
      // }

      //params.photoList = photoList;

      params.undertakerId =
        this.SpaceManagement.spaceDetails.details.undertakerId;

      if (updateContinue == 0 && this.SpaceManagement.spaceDetails.details.claimState == 1) {
        params.updateContinue = 0
      } else {
        params.updateContinue = 1
      }

      console.log(params);

      if (this.SpaceManagement.spaceDetails.details.claimState == 1 && updateContinue == 0) {
        this.$confirm(
          "您确定要对此次操作进行保存并结束，如果保存并结束后再次进行操作需获取客户短信，方可操作",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.toEditById(params);
          })
          .catch(() => { });
      } else {
        this.toEditById(params);
      }
    },

    toEditById(params) {
      this.editById(params).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("操作成功");
          this.refresh(false, "");
        } else if (res.status == 1061) {
          this.$message.error("剩余纪念堂大小不足");
        } else if (res.status == 1080) {
          this.$message.error("纪念堂成员数量已达上限");
        } else if (res.status == 1069) {
          this.$message.error("管理员手机号重复");
        } else if (res.status == 1117) {
          this.$message.error(res.message);
        } else if (res.status == 1015) {
          this.$message.error(res.message);
        } else if (res.status == 1054) {
          this.$message.error(res.message);
          this.refreshMiddle();
        } else if (res.status == 1098) {
          this.showCo();
        } else {
          this.$message.error("保存失败");
        }
      });
    },

    upLoadFinish() {
      if (this.SpaceManagement.spaceDetails.details.claimState == 1) {
        this.$confirm(
          "您确定要对此次操作进行结束上传吗？如果结束操作后再进行操作需获取客户短信，方可操作",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.toCancelUploadStateById();
          })
          .catch(() => { });
      } else {
        this.toCancelUploadStateById();
      }
    },

    toCancelUploadStateById() {
      let data = this.SpaceManagement.spaceDetails.details.id;
      this.cancelUploadStateById(data).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("操作成功");
          this.findByIdAnother(this.$route.query.id).then((resb) => {
            if (resb.status == 1000) {
              if (resb.data.uploadState == 1) {
                this.uploadState = false;
              } else {
                this.uploadState = true;
              }
              this.SpaceManagement.spaceDetails.details.claimState =
                resb.data.claimState;
            } else if (resb.status == 1098) {
              this.showCo();
            }
          });
        } else if (res.status == 1098) {
          this.showCo();
        } else {
          this.$message.error(res.message || "系统异常");
        }
      });
    },

    closeAll() {
      if (this.SpaceManagement.spaceDetails.updateState) {
        window.opener = null;
        window.open("about:blank", "_top").close();
      } else {
        if (
          this.SpaceManagement.spaceDetails.overUrlOld == undefined ||
          this.SpaceManagement.spaceDetails.overUrlOld == ""
        ) {
          window.opener = null;
          window.open("about:blank", "_top").close();
        } else {
          this.$confirm(
            "关闭后，修改的内容将不再保存，是否确定要关闭此页面？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              window.opener = null;
              window.open("about:blank", "_top").close();
            })
            .catch(() => { });
        }
      }
    },

    updateLog() {
      this.tableLog = true;
      let params = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
      };
      this.findUploadByDmId(params).then((res) => {
        if (res.status == 1098) {
          this.showCo();
        }
      });
    },

    handleCloseLog(done) {
      this.SpaceManagement.spaceDetails.spaceLogForm = {
        createUserName: "",
        content: "",
        date: "",
      };
      this.SpaceManagement.spaceDetails.logList = [""];
      this.SpaceManagement.spaceDetails.numberLog = "";
      done();
    },

    handleCurrentChangeLog(v) {
      let params = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
      };
      this.findUploadByDmId(params).then((res) => {
        if (res.status == 1098) {
          this.showCo();
        }
      });
    },

    searchLog() {
      let params = {
        dmId: this.SpaceManagement.spaceDetails.details.id,
      };
      this.findUploadByDmId(params).then((res) => {
        if (res.status == 1098) {
          this.showCo();
        }
      });
    },

    showCo() {
      this.$Confirm("纪念堂已失效，请返回纪念堂列表页面刷新", "提示", {
        type: "warning",
        showCancelButton: false,
      })
        .then(() => {
          window.opener = null;
          window.open("about:blank", "_top").close();
        })
        .catch(() => {
          window.opener = null;
          window.open("about:blank", "_top").close();
        });
    },
    getAllBgTemplateV2(){
      this.findAllBgTemplateV2().then((resa) => {
        console.log(resa);
        this.listArr = resa.data;
        if (!this.TemplateSettingsFromData.bgId) {
          this.TemplateSettingsFromData.bgId = this.listArr[0].id;
          this.indexBack = 0;
        } else {
          this.indexBack = -1;
          this.listArr.forEach((item, index) => {
            if (item.bgId == this.TemplateSettingsFromData.bgId) {
              this.indexBack = index;
            }
          });
        }
        this.bgTemplateTitleClick(this.TemplateSettingsFromData.bgId >= 9000 ? "NEW" : "OLD");
      });
    },
    bgTemplateTitleClick(type){
      if(type == "NEW"){
        this.bgTemplateTitleNewClass = "bg_template_title select";
        this.bgTemplateTitleOldClass = "bg_template_title";
        this.bgTemplateBodyNewShow = true;
        this.bgTemplateBodyOldShow = false;
      }else if(type == "OLD"){
        this.bgTemplateTitleNewClass = "bg_template_title";
        this.bgTemplateTitleOldClass = "bg_template_title select";
        this.bgTemplateBodyNewShow = false;
        this.bgTemplateBodyOldShow = true;
      }
    }
  },
};
</script>

<style lang="stylus" scoped>

  // .calendar_dialog >>> .el-dialog__body{
  //   padding: 0rem 2rem 0 2rem;
  // }
.calerdar_chocie {
  width:190px;
  font-size: 14px;
  height:40px;
  line-height:40px;
  border: 1px solid #DCDFE6;
  color:#000000;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  .calerdar_chocie_none {
    color:#DCDFE6;
  }
}

.v_item_name {
  max-width: 190px;
  overflow: hidden; // 超出部分隐藏
  text-overflow: ellipsis; // 隐藏部分用...代替
  white-space: nowrap;
}

.search_item >>>.el-input__icon {
  margin-top: 1px;
}

.search_itemb {
  float: left;
  height: 40px;
}

.search_itemb >>>.el-form-item__label {
  color: #040300;
}

.search_button {
  width: 100px;
}

.search_area_log_middle {
  overflow: auto;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  top: 80px;
}

.search_area_log_search {
  margin-left: 30px;
  width: 1210px;
  height: 60px;
  line-height: 60px;
  background: #F1F4F9;
  border-top: 1px solid #CCD7EA;
  border-left: 1px solid #CCD7EA;
  border-right: 1px solid #CCD7EA;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  padding-left: 30px;
  box-sizing: border-box;
}

.search_area_log {
  margin-left: 30px;
  width: 1210px;
  border: 1px solid #CCD7EA;
  height: 80px;
  padding-top: 20px;
  box-sizing: border-box;
}

.table_area_log_all {
  background-color: #fff;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 1210px;
  top: 140px;
  overflow: auto;
  margin-left: 30px;
}

.table_area_log_item_all {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.table_area_log_item_all_img {
  width: 40px;
  height: 40px;
  border-radius: 2px;
  overflow: hidden;
  object-fit: cover;
}

.table_area_log_item_all_text {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  height: 40px;
  line-height: 40px;
  width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.log_number_all {
  height: 62px;
  line-height: 62px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

.log_number_blue {
  font-size: 16px;
  font-weight: 500;
  color: #2C90FF;
}

.table_area_log >>>.el-table th {
  background-color: #F7FAFF !important;
}

.table_area_log >>> .cell {
  margin-left: 40px;
}

.v_title_button {
  position: absolute;
  right: 15px;
  top: 300px;
  width: 130px;
  height: 350px;
  z-index: 200;
}

.v_title_button_a {
  width: 129px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-radius: 30px 0px 0px 30px;
  background: #2C90FF;
  font-size: 22px;
  font-weight: 500;
  color: #FFFFFF;
  cursor: pointer;
}

.v_title_button_b {
  width: 129px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-radius: 30px 0px 0px 30px;
  border-left: 1px solid #2C90FF;
  border-top: 1px solid #2C90FF;
  border-bottom: 1px solid #2C90FF;
  font-size: 22px;
  font-weight: 400;
  color: #2F8BFF;
  cursor: pointer;
  background: #ffffff;
}

.space_details_background {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: auto;

  .space_details_title_all {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .iv_close {
    width: 28px;
    height: 28px;
    margin-right: 50px;
    cursor: pointer;
  }

  .space_details_title {
    font-size: 34px;
    font-weight: 500;
    color: #000000;
    height: 108px;
    line-height: 108px;
    margin-left: 60px;
  }

  .space_title {
    width: 1800px;
    height: 60px;
    line-height: 60px;
    background: #F1F4F9;
    border: 1px solid #CCD7EA;
    margin-left: 60px;
    padding-left: 30px;
    box-sizing: border-box;
    font-size: 22px;
    font-weight: 500;
    color: #000000;
  }

  .space_title_message {
    width: 1798px;
    margin-left: 60px;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #CCD7EA;
    border-right: 1px solid #CCD7EA;
    border-bottom: 1px solid #CCD7EA;
  }

  .space_title_message_conent {
    margin-top: 15px;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    line-height: 50px;
  }

  .titl_text {
    margin-left: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #949494;
    line-height: 50px;
  }

  .titl_message {
    margin-left: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    line-height: 50px;
  }

  .title_midddle_button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;

    .title_midddle_button_text {
      font-size: 14px;
      font-weight: 400;
      color: #040300;
    }
  }

  .title_midddle_button_text_bg {
    color: #040300;
    height:60px;
    line-height:60px;
    font-size:14px;
  }

  .v_line {
    margin-left: 30px;
    width: 1740px;
    height: 1px;
    background: #CCD7EA;
    margin-bottom: 20px;
  }

  .title_bottom_button_list {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .title_bottom_button_list_item {
    width:240px;
  }

  .title_bottom_button_list_item_img {
    width:240px;
    height: 135px;
  }

  .title_bottom_button_list_item_img_v {
    width:240px;
    height: 353px;
  }

  .title_bottom_button_list_item_bottom {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  // .title_bottom_button {
  //   display: flex;
  //   flex-direction: row;
  //   align-items: center;
  //   justify-content: center;
  //   margin-bottom: 30px;
  // }

  .v_orange.el-button--primary {
    background: #F66915 !important;
    color: #FFFFFF;
    border: 1px solid #F66915 !important;
  }

  .v_orange_gray {
    background: #c8c9cc;
    color: #FFFFFF;
    border: 1px solid #c8c9cc;
  }

  .v_green {
    background: #F66915 !important;
    color: #FFFFFF;
    border: 1px solid #F66915 !important;
  }

  .space_change_all {
    width: 1800px;
    border: 1px solid #CCD7EA;
    margin-left: 60px;
    margin-top: 50px;
  }

  .space_change_all_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    background: #F1F4F9;
    border-bottom: 1px solid #CCD7EA;
  }

  .space_change_all_title_text {
    height: 60px;
    font-size: 22px;
    font-weight: 500;
    color: #000000;
    line-height: 60px;
    margin-left: 30px;
  }

  .space_homepage_message {
    margin-right: 30px;
    height: 40px;
    width: 190px;
  }

  .space_homepage_message_a {
    height: 40px;
    width: 190px;
  }

  .space_homepage {
    display: flex;
    flex-direction: row;

    .space_homepage_title {
      margin-top: 30px;
      width: 120px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: #F1F4F9;
      border-top: 1px solid #CCD7EA;
      border-left: 1px solid #CCD7EA;
      border-right: 1px solid #CCD7EA;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      margin-left: 30px;
    }
  }

  .space_homepage_middle {
    margin-left: 30px;
    width: 1740px;
    background: #FFFFFF;
    border: 1px solid #CCD7EA;
  }

  .search_input {
    width: 220px;
  }

  .search_input_new {
    width: 180px;
  }

  .search_area {
    margin-top: 30px;
  }

  .search_area >>>.el-form-item__label {
    color: #040300;
  }

  .search_area >>> .el-form-item__error {
    width: 310px;
  }

  .v_line_middle {
    margin-left: 30px;
    width: 1680px;
    height: 1px;
    background: #CCD7EA;
  }

  .page_area {
    height: 30px;
    padding-top: 35px;
    padding-bottom: 15px;

    .el-pagination {
      text-align: center;
    }

    .el-pagination__total {
      color: #333333;
      font-size: 12px;
    }
  }

  .visitors_to_code {
    margin-top: 30px;
    width: 120px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #F1F4F9;
    border-top: 1px solid #CCD7EA;
    border-left: 1px solid #CCD7EA;
    border-right: 1px solid #CCD7EA;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-left: 30px;
  }

  .visitors_to_code_s {
    margin-top: 50px;
    width: 1800px;
    height: 60px;
    background: #F1F4F9;
    border-top: 1px solid #CCD7EA;
    border-left: 1px solid #CCD7EA;
    border-right: 1px solid #CCD7EA;
    margin-left: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .visitors_to_code_s_title {
    font-size: 22px;
    font-weight: 500;
    color: #000000;
    line-height: 60px;
    margin-left: 30px;
  }

  .visitors_body_update {
    background: #FFFFFF;
    border: 1px solid #CCD7EA;
    margin-left: 60px;
    width: 1800px;
    margin-bottom: 40px;
    // height: 550px;
    position: relative;
  }

  .lifeAlbum_body {
    margin-top: 50px;
    width: 1800px;
    height: 60px;
    background: #F1F4F9;
    border-top: 1px solid #CCD7EA;
    border-left: 1px solid #CCD7EA;
    border-right: 1px solid #CCD7EA;
    margin-left: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .lifeAlbum_title {
    font-size: 22px;
    font-weight: 500;
    color: #000000;
    line-height: 60px;
    margin-left: 30px;
  }

  .lifeAlbum_content {
    z-index: 0;
    background: #FFFFFF;
    border: 1px solid #CCD7EA;
    margin-left: 60px;
    width: 1800px;
    margin-bottom: 40px;
    // height: 550px;
    position: relative;
  }

  .visitors_body {
    margin-left: 30px;
    margin-bottom: 30px;
    width: 1740px;
    background: #FFFFFF;
    border: 1px solid #CCD7EA;
  }

  .headline_title {
    margin-left: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #040300;
    height: 50px;
    line-height: 50px;
  }
  .template_list {
    width:1600px;
    min-height:56px;
    margin-left:30px;
    display:flex;
    flex-wrap:wrap;

    .blank {
      font-size:14px;
      color:#B5B5B5;
      height:50px;
      line-height:50px;
    }

    .template_btn_area {
      height:48px;
      position:relative;
      margin-right:20px;
      margin-bottom:10px;

      .name {
        height: 20px;
        font-size: 14px;
        color: #3A81FF;
        line-height: 20px;
        padding:10px 15px;
        border-radius:4px;
        background:#E1EFFF;
        display:inline-block;
        min-width:30px;
        cursor:pointer;

      }
      .name.selected {
        background:#3A81FF;
        color:#ffffff;
      }
      .img_template_triangle {
        width:24px;
        height:8px;
        position:absolute;
        left:10px;
        top:39px;
      }
    }
    .template_btn_area.disable .name { 
      cursor:not-allowed !important;
    }
    // .template_btn_area + .template_btn_area {
    //   margin-left:20px;
    // }
  }

  .headline_input {
    width: 1680px;
    margin-left: 30px;
  }

  .headline_input >>>.el-input__inner {
    color: #000000;
  }

  .headline_input.is-disabled >>>.el-input__inner {
    color: #C0C4CC;
  }

  .v_template {
    font-size: 14px;
    font-weight: 400;
    color: #040300;
    height: 70px;
    line-height: 70px;
    margin-left: 30px;
  }

  .v_template_name {
    font-size: 14px;
    font-weight: 400;
    color: #2C90FF;
  }

  .bg_template_title {
    float: left;
    margin-top: 30px;
    width: 120px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #F1F4F9;
    border-top: 1px solid #CCD7EA;
    border-left: 1px solid #CCD7EA;
    border-right: 1px solid #CCD7EA;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-left: 30px;
    cursor: pointer;
  }

  .bg_template_title.select {
    background: #0691FF;
    color: #FFF;
  }

  .bg_template_body {
    clear: both;
    margin-left: 30px;
    margin-bottom: 30px;
    width: 168rem;
    background: #FFFFFF;
    border: 1px solid #CCD7EA;
  }

  .v_template_imgs {
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .bg_template_body_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      margin-top: 3rem;
      margin-left: 3.9rem;
    }

    .v_template_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }

    .iv_choice_title {
      position: absolute;
      top: 0;
      right: 0;
      width: 80px;
      height: 50px;
    }

    .iv_template {
      width: 175px;
      height: 103px;
    }

    // width: 340px;
    // height: 200px;
    .iv_music {
      width: 175px;
      height: 180px;
    }

    .iv_music_button {
      width: 38px;
      height: 38px;
      position: absolute;
      left: 68px;
      top: 71px;
    }

    .iv_music_button_text {
      line-height: 20px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #FFFFFF;
      position: absolute;
      top: 119px;
    }

    .chocie_template {
      width: 175px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 70px;
      line-height: 70px;
    }

    .iv_choice_icon {
      margin-right: 10px;
      width: 17px;
      height: 17px;
    }
  }

  .v_add_people {
    width: 100px;
    float: right;
    margin-right: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .create_people_input >>>.el-input__inner {
    border: 0;
    background: #00000000;
    padding-left: 0px;
  }

  .create_people_input_a >>>.el-input__inner {
    border: 0;
    background: #00000000;
    padding-left: 0px;
  }

  .progress_top_new {
    width: 100%;
    height: 122px;
  }

  .progress_top_left_new {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 72px;
    line-height: 72px;
  }

  .progress_top_left_new_text {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    margin-left: 30px;
  }

  .progress_top_left_new_right_text {
    font-size: 14px;
    font-weight: 400;
    color: #949494;
    margin-right: 30px;
  }

  .progress_line_new {
    width: 1740px;
    margin-left: 30px;
    height: 20px;
    background: #E1EFFF;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .progress_line_new_blue {
    background: #0884FF;
    height: 20px;
  }

  .progress_line_new_pink {
    height: 20px;
    background: #C845F3;
  }

  .progress_line_new_gray {
    height: 20px;
  }

  .upload_middle {
    display: flex;
    flex-direction: row;
    justify-content: center;
    // align-items: center;
    width: 100%;
    height: 140px;
  }

  .upload_middle_item {
    width: 272px;
    height: 110px;
    background: #FFFFFF;
    border: 1px solid #D4DDED;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .iv_upload_middle_item {
    margin-right: 27px;
    margin-left: 27px;
    width: 76px;
    height: 76px;
  }

  .v_upload_middle_number {
    font-size: 30px;
    font-weight: 500;
  }

  .v_upload_middle_text {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #949494;
  }

  .v_photo_album_list {
    margin-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .v_photo_album_list_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }

    .v_photo_album_list_item_change {
      position: absolute;
      top: 0;
      right: 0;
      width: 84px;
      height: 79px;
      cursor: pointer;
    }

    .v_photo_album_list_item_photo_count {
      position:absolute;
      right:0;
      top:215px;
      height: 35px;
      line-height:35px;
      cursor: pointer;
      background:rgba(0,0,0,0.3)
      border-radius: 0 0 10px 0;
      padding: 0 20px;
      max-width:200px;
      font-size:14px;
      color:#ffffff;
    }

    .v_photo_album_list_item_change_add {
      position: absolute;
      top: 85px;
      left: 85px;
      width: 80px;
      height: 80px;
      cursor: pointer;
    }

    .iv_photo_album_list_item {
      width: 250px;
      height: 250px;
      //border: 1px solid #CCD7EA;
      cursor: pointer;
      object-fit:cover;
      border-radius: 10px;
    }

    .iv_photo_album_list_item_none {
      width: 250px;
      height: 250px;
      border: 1px solid #CCD7EA;
      position: relative;
      border-radius: 10px;
    }

    .v_photo_album_list_item_bottom {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 250px;
      height: 40px;
      line-height: 40px;
      margin-bottom:20px;
    }

    .v_photo_album_list_item_bottom_title {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      margin-left: 10px;
    }

    .iv_photo_album_list_item_bottom_right {
      width: 3px;
      height: 13px;
      padding-right: 10px;
      padding-left: 10px;
      cursor: pointer;
    }

    .v_photo_album_list_item_float {
      position: absolute;
      right: 23px;
      bottom: 14px;
      width: 126px;
      max-height: 121px;
      background: #FFFFFF;
      box-shadow: 0px 0px 8px 2px rgba(222, 222, 222, 0.5);
      border-radius: 5px;
    }

    .v_photo_album_list_item_float_all {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }

    .iv_photo_album_list_item_float_icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    .v_photo_album_list_item_float_black {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
    }

    .v_photo_album_list_item_float_red {
      font-size: 14px;
      font-weight: 400;
      color: #FF3F3F;
    }

    .v_photo_album_list_item_float_line {
      margin-left: 20px;
      width: 86px;
      height: 1px;
      background: #D5D5D5;
    }
  }

  .upLoadVideo_all {
    margin-left: 840px;
  }

  .upLoadVideo {
    width: 120px;
    margin-top: 30px;
    margin-bottom: 30px;
    height: 40px;
  }

  .upLoadVideo_no {
    margin-left: 840px;
    width: 120px;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .search_itema {
    display: flex;
    flex-direction: column;
  }

  .search_itema >>>.el-form-item__label {
    height: 50px;
    line-height: 50px;
    color: #040300;
  }

  .search_itema >>> .el-form-item__content {
    margin-left: 30px !important;
  }

  .search_itema >>>.avatar-uploader {
    width: 171px;
    height: 228px;

    .el-upload {
      position: relative;
      width: 171px;
      height: 228px;
      border-radius: 2px;
    }

    .el-upload:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 171px;
      height: 228px;
      text-align: center;

      img {
        position: absolute;
        left: 60px;
        top: 60px;
        width: 50px;
        height: 50px;
      }

      p {
        position: absolute;
        left: 60px;
        top: 120px;
        font-size: 12px;
        font-weight: 400;
        color: #B7B7B7;
        height: 17px;
        line-height: 17px;

        span {
          color: #3A81FF;
        }
      }
    }

    .avatar {
      width: 350px;
      height: 105px;
      display: block;
    }

    .cover {
      width: 171px;
      height: 228px;
      display: block;
    }
  }

  .search_itema >>>.el-upload-dragger {
    width: 171px;
    height: 228px;
  }

  .search_itema >>>.coverUrlBorder {
    .el-upload {
      border: 0;
      cursor: not-allowed;

      img {
        width: 171px;
        height: 228px;
      }
    }
  }

  .dialog_body_message {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .phone_message {
    margin-right: 30px;
    width: 160px;
  }

  .phone_message_text {
    margin-right: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #040300;
  }

  .message_to_phone {
    color: #FFFFFF;
    background: #F66915;
    border: 1px solid #F66915;
    width: 110px;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    padding: 0;
  }

  .cemetery_use {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
  }

  .cemetery_use_title {
    font-size: 14px;
    font-weight: 400;
    color: #040300;
    width: 75px;
  }

  .search_input_big {
    width: 220px;
    position: relative;
  }

  .search_input_big_number {
    position: absolute;
    right: 150px;
    bottom: 8px;
    color: #2C90FF;
    font-size: 14px;
    background: #fff;
  }

  .search_input_big_number_b {
    position: absolute;
    right: 130px;
    bottom: 8px;
    color: #2C90FF;
    font-size: 14px;
    background: #fff;
  }

  .search_input_big_number_a {
    color: #000000;
    font-size: 14px;
  }

  .search_input_big >>> .el-textarea__inner {
    font-family: 'Microsoft Yahei', '微软雅黑', Arial, sans-serif;
    color: #000000;
  }

  .wang_editor_all_number {
    position: absolute;
    right: 20px;
    bottom: 10px;
    z-index: 100;
  }

  .wang_editor_all {
    position: relative;
  }

  .wang_editor_all >>> .w-e-text-container {
    z-index: 100 !important;
  }

  .wang_editor_all >>> .w-e-menue-mantle {
    z-index: 100 !important;
  }

  .wang_editor_all >>> .w-e-toolbar {
    z-index: 101 !important;
  }

  .freezeSpace {
    margin-bottom: 30px;
    display: flex;
    position: relative;
    justify-content: center;
  }

  .cemetery_use_title_b {
    width: 160px;
  }
}
</style>

<style lang="stylus">
.drawer_change .el-drawer__header {
  font-size: 34px;
  font-weight: 500;
  color: #000000;
}

.drawer_change .el-drawer__close-btn {
  font-size: 30px;
}

.drawer_change .el-drawer__body {
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/PartII/SpaceDetails/components/SpaceDetails.vue